import * as Bn from "vue";
import { defineComponent as ft, h as gn, getCurrentScope as ea, onScopeDispose as ta, inject as na, onMounted as An, onUnmounted as oa, Fragment as Ce, computed as Ne, watch as bt, ref as J, shallowRef as sa, createVNode as Tt, Text as ra, openBlock as H, createElementBlock as Y, createElementVNode as g, renderList as Ke, withDirectives as qe, vModelText as pt, vModelSelect as Ts, toDisplayString as z, reactive as Ls, normalizeClass as Pe, createCommentVNode as $e, unref as W, Transition as lo, withCtx as co, createTextVNode as Lt, vModelDynamic as aa } from "vue";
import { logger as qn } from "@myorg/type-lib";
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function nt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Uo = {};
function ia(e) {
  Uo[e] || (Uo[e] = !0, nt(e));
}
const dt = typeof window < "u";
let Me, Ot;
if (process.env.NODE_ENV !== "production") {
  const e = dt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Me = (t) => {
    e.mark(t);
  }, Ot = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const la = /\{([0-9a-zA-Z]+)\}/g;
function On(e, ...t) {
  return t.length === 1 && Z(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(la, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const mt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), ca = (e, t, n) => ua({ l: e, k: t, s: n }), ua = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), ke = (e) => typeof e == "number" && isFinite(e), Ns = (e) => fo(e) === "[object Date]", wn = (e) => fo(e) === "[object RegExp]", In = (e) => se(e) && Object.keys(e).length === 0, _e = Object.assign, da = Object.create, ae = (e = null) => da(e);
let Bo;
const Nt = () => Bo || (Bo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : ae());
function Vo(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function fa(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const ma = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, pa = /^(?:href|src|action|formaction)$/i;
function uo(e) {
  return ma.test(e);
}
function ha(e) {
  const t = /url\s*\(/gi;
  let n = "", o = 0, s;
  for (; (s = t.exec(e)) !== null; ) {
    const r = s.index, a = t.lastIndex - 1;
    let l = a + 1, i = 1, d = null;
    for (; l < e.length; l++) {
      const p = e[l];
      if (d) {
        p === d && (d = null);
        continue;
      }
      if (p === '"' || p === "'")
        d = p;
      else if (p === "(")
        i++;
      else if (p === ")" && (i--, i === 0))
        break;
    }
    if (i !== 0)
      break;
    const h = e.slice(a + 1, l).trim(), w = h.startsWith('"') && h.endsWith('"') || h.startsWith("'") && h.endsWith("'") ? h.slice(1, -1).trim() : h;
    n += e.slice(o, r), n += uo(w) ? "url(about:blank)" : e.slice(r, l + 1), o = l + 1;
  }
  return n + e.slice(o);
}
function Ho(e, t) {
  if (pa.test(e) && uo(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? ha(t) : t;
  return fa(n);
}
function ga(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, o, s) => `${o}="${Ho(o, s)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, o, s) => `${o}='${Ho(o, s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && nt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, o, s) => uo(s) ? `${o}about:blank` : n), e;
}
const wa = Object.prototype.hasOwnProperty;
function Ye(e, t) {
  return wa.call(e, t);
}
const ge = Array.isArray, ue = (e) => typeof e == "function", M = (e) => typeof e == "string", he = (e) => typeof e == "boolean", Z = (e) => e !== null && typeof e == "object", ba = (e) => Z(e) && ue(e.then) && ue(e.catch), As = Object.prototype.toString, fo = (e) => As.call(e), se = (e) => fo(e) === "[object Object]", va = (e) => e == null ? "" : ge(e) || se(e) && e.toString === As ? JSON.stringify(e, null, 2) : String(e);
function mo(e, t = "") {
  return e.reduce((n, o, s) => s === 0 ? n + o : n + t + o, "");
}
const Yo = 2;
function _a(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (s += o[a].length + 1, s >= t) {
      for (let l = a - Yo; l <= a + Yo || n > s; l++) {
        if (l < 0 || l >= o.length)
          continue;
        const i = l + 1;
        r.push(`${i}${" ".repeat(3 - String(i).length)}|  ${o[l]}`);
        const d = o[l].length;
        if (l === a) {
          const h = t - (s - d) + 1, w = Math.max(1, n > s ? d - h : n - t);
          r.push("   |  " + " ".repeat(h) + "^".repeat(w));
        } else if (l > a) {
          if (n > s) {
            const h = Math.max(Math.min(n - s, d), 1);
            r.push("   |  " + "^".repeat(h));
          }
          s += d + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Os() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const s = e.get(n);
      s && s.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const s = e.get(n);
      s && s.splice(s.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((s) => s(o)), (e.get("*") || []).slice().map((s) => s(n, o));
    }
  };
}
const dn = (e) => !Z(e) || ge(e);
function hn(e, t) {
  if (dn(e) || dn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: s } = n.pop();
    Object.keys(o).forEach((r) => {
      r !== "__proto__" && (Z(o[r]) && !Z(s[r]) && (s[r] = Array.isArray(o[r]) ? [] : ae()), dn(s[r]) || dn(o[r]) ? s[r] = o[r] : n.push({ src: o[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function ya(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Xn(e, t, n) {
  return { start: e, end: t };
}
const G = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Ea = 17, ka = {
  // tokenizer error messages
  [G.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [G.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [G.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [G.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [G.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [G.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [G.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [G.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [G.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [G.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [G.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [G.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [G.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [G.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [G.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Yt(e, t, n = {}) {
  const { domain: o, messages: s, args: r } = n, a = process.env.NODE_ENV !== "production" ? On((s || ka)[e] || "", ...r || []) : e, l = new SyntaxError(String(a));
  return l.code = e, t && (l.location = t), l.domain = o, l;
}
function xa(e) {
  throw e;
}
const Ca = /<\/?[\w\s="/.':;#-\/]+>/, Ta = (e) => Ca.test(e), Ze = " ", La = "\r", Le = `
`, Na = "\u2028", Aa = "\u2029";
function Oa(e) {
  const t = e;
  let n = 0, o = 1, s = 1, r = 0;
  const a = (E) => t[E] === La && t[E + 1] === Le, l = (E) => t[E] === Le, i = (E) => t[E] === Aa, d = (E) => t[E] === Na, h = (E) => a(E) || l(E) || i(E) || d(E), w = () => n, p = () => o, x = () => s, A = () => r, y = (E) => a(E) || i(E) || d(E) ? Le : t[E], k = () => y(n), m = () => y(n + r);
  function f() {
    return r = 0, h(n) && (o++, s = 0), a(n) && n++, n++, s++, t[n];
  }
  function T() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function _() {
    n = 0, o = 1, s = 1, r = 0;
  }
  function N(E = 0) {
    r = E;
  }
  function O() {
    const E = n + r;
    for (; E !== n; )
      f();
    r = 0;
  }
  return {
    index: w,
    line: p,
    column: x,
    peekOffset: A,
    charAt: y,
    currentChar: k,
    currentPeek: m,
    next: f,
    peek: T,
    reset: _,
    resetPeek: N,
    skipToPeek: O
  };
}
const at = void 0, Ia = ".", jo = "'", Sa = "tokenizer";
function Da(e, t = {}) {
  const n = t.location !== !1, o = Oa(e), s = () => o.index(), r = () => ya(o.line(), o.column(), o.index()), a = r(), l = s(), i = {
    currentType: 13,
    offset: l,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: l,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => i, { onError: h } = t;
  function w(c, u, C, ...$) {
    const ce = d();
    if (u.column += C, u.offset += C, h) {
      const me = n ? Xn(ce.startLoc, u) : null, ee = Yt(c, me, {
        domain: Sa,
        args: $
      });
      h(ee);
    }
  }
  function p(c, u, C) {
    c.endLoc = r(), c.currentType = u;
    const $ = { type: u };
    return n && ($.loc = Xn(c.startLoc, c.endLoc)), C != null && ($.value = C), $;
  }
  const x = (c) => p(
    c,
    13
    /* TokenTypes.EOF */
  );
  function A(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (w(G.EXPECTED_TOKEN, r(), 0, u), "");
  }
  function y(c) {
    let u = "";
    for (; c.currentPeek() === Ze || c.currentPeek() === Le; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function k(c) {
    const u = y(c);
    return c.skipToPeek(), u;
  }
  function m(c) {
    if (c === at)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function f(c) {
    if (c === at)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function T(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    y(c);
    const $ = m(c.currentPeek());
    return c.resetPeek(), $;
  }
  function _(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    y(c);
    const $ = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), ce = f($);
    return c.resetPeek(), ce;
  }
  function N(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    y(c);
    const $ = c.currentPeek() === jo;
    return c.resetPeek(), $;
  }
  function O(c, u) {
    const { currentType: C } = u;
    if (C !== 7)
      return !1;
    y(c);
    const $ = c.currentPeek() === ".";
    return c.resetPeek(), $;
  }
  function E(c, u) {
    const { currentType: C } = u;
    if (C !== 8)
      return !1;
    y(c);
    const $ = m(c.currentPeek());
    return c.resetPeek(), $;
  }
  function K(c, u) {
    const { currentType: C } = u;
    if (!(C === 7 || C === 11))
      return !1;
    y(c);
    const $ = c.currentPeek() === ":";
    return c.resetPeek(), $;
  }
  function j(c, u) {
    const { currentType: C } = u;
    if (C !== 9)
      return !1;
    const $ = () => {
      const me = c.currentPeek();
      return me === "{" ? m(c.peek()) : me === "@" || me === "|" || me === ":" || me === "." || me === Ze || !me ? !1 : me === Le ? (c.peek(), $()) : q(c, !1);
    }, ce = $();
    return c.resetPeek(), ce;
  }
  function V(c) {
    y(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function q(c, u = !0) {
    const C = (ce = !1, me = "") => {
      const ee = c.currentPeek();
      return ee === "{" || ee === "@" || !ee ? ce : ee === "|" ? !(me === Ze || me === Le) : ee === Ze ? (c.peek(), C(!0, Ze)) : ee === Le ? (c.peek(), C(!0, Le)) : !0;
    }, $ = C();
    return u && c.resetPeek(), $;
  }
  function U(c, u) {
    const C = c.currentChar();
    return C === at ? at : u(C) ? (c.next(), C) : null;
  }
  function ie(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function S(c) {
    return U(c, ie);
  }
  function I(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function D(c) {
    return U(c, I);
  }
  function F(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function P(c) {
    return U(c, F);
  }
  function X(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function B(c) {
    return U(c, X);
  }
  function Q(c) {
    let u = "", C = "";
    for (; u = P(c); )
      C += u;
    return C;
  }
  function le(c) {
    let u = "";
    for (; ; ) {
      const C = c.currentChar();
      if (C === "\\") {
        const $ = c.peek();
        $ === "{" || $ === "}" || $ === "@" || $ === "|" || $ === "\\" ? (u += C + $, c.next(), c.next()) : (c.resetPeek(), u += C, c.next());
      } else {
        if (C === "{" || C === "}" || C === "@" || C === "|" || !C)
          break;
        if (C === Ze || C === Le)
          if (q(c))
            u += C, c.next();
          else {
            if (V(c))
              break;
            u += C, c.next();
          }
        else
          u += C, c.next();
      }
    }
    return u;
  }
  function de(c) {
    k(c);
    let u = "", C = "";
    for (; u = D(c); )
      C += u;
    const $ = c.currentChar();
    if ($ && $ !== "}" && $ !== at && $ !== Ze && $ !== Le && $ !== "　") {
      const ce = ve(c);
      return w(G.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C + ce), C + ce;
    }
    return c.currentChar() === at && w(G.UNTERMINATED_CLOSING_BRACE, r(), 0), C;
  }
  function be(c) {
    k(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${Q(c)}`) : u += Q(c), c.currentChar() === at && w(G.UNTERMINATED_CLOSING_BRACE, r(), 0), u;
  }
  function Te(c) {
    return c !== jo && c !== Le;
  }
  function st(c) {
    k(c), A(c, "'");
    let u = "", C = "";
    for (; u = U(c, Te); )
      u === "\\" ? C += We(c) : C += u;
    const $ = c.currentChar();
    return $ === Le || $ === at ? (w(G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), $ === Le && (c.next(), A(c, "'")), C) : (A(c, "'"), C);
  }
  function We(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return ze(c, u, 4);
      case "U":
        return ze(c, u, 6);
      default:
        return w(G.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, u), "";
    }
  }
  function ze(c, u, C) {
    A(c, u);
    let $ = "";
    for (let ce = 0; ce < C; ce++) {
      const me = B(c);
      if (!me) {
        w(G.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${u}${$}${c.currentChar()}`);
        break;
      }
      $ += me;
    }
    return `\\${u}${$}`;
  }
  function Ge(c) {
    return c !== "{" && c !== "}" && c !== Ze && c !== Le;
  }
  function ve(c) {
    k(c);
    let u = "", C = "";
    for (; u = U(c, Ge); )
      C += u;
    return C;
  }
  function Be(c) {
    let u = "", C = "";
    for (; u = S(c); )
      C += u;
    return C;
  }
  function rt(c) {
    const u = (C) => {
      const $ = c.currentChar();
      return $ === "{" || $ === "@" || $ === "|" || $ === "(" || $ === ")" || !$ || $ === Ze ? C : (C += $, c.next(), u(C));
    };
    return u("");
  }
  function Je(c) {
    k(c);
    const u = A(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return k(c), u;
  }
  function Xt(c, u) {
    let C = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && w(G.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), c.next(), C = p(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), k(c), u.braceNest++, C;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && w(G.EMPTY_PLACEHOLDER, r(), 0), c.next(), C = p(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && k(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), C;
      case "@":
        return u.braceNest > 0 && w(G.UNTERMINATED_CLOSING_BRACE, r(), 0), C = yt(c, u) || x(u), u.braceNest = 0, C;
      default: {
        let ce = !0, me = !0, ee = !0;
        if (V(c))
          return u.braceNest > 0 && w(G.UNTERMINATED_CLOSING_BRACE, r(), 0), C = p(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, C;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return w(G.UNTERMINATED_CLOSING_BRACE, r(), 0), u.braceNest = 0, zt(c, u);
        if (ce = T(c, u))
          return C = p(u, 4, de(c)), k(c), C;
        if (me = _(c, u))
          return C = p(u, 5, be(c)), k(c), C;
        if (ee = N(c, u))
          return C = p(u, 6, st(c)), k(c), C;
        if (!ce && !me && !ee)
          return C = p(u, 12, ve(c)), w(G.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C.value), k(c), C;
        break;
      }
    }
    return C;
  }
  function yt(c, u) {
    const { currentType: C } = u;
    let $ = null;
    const ce = c.currentChar();
    switch ((C === 7 || C === 8 || C === 11 || C === 9) && (ce === Le || ce === Ze) && w(G.INVALID_LINKED_FORMAT, r(), 0), ce) {
      case "@":
        return c.next(), $ = p(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, $;
      case ".":
        return k(c), c.next(), p(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return k(c), c.next(), p(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return V(c) ? ($ = p(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, $) : O(c, u) || K(c, u) ? (k(c), yt(c, u)) : E(c, u) ? (k(c), p(u, 11, Be(c))) : j(c, u) ? (k(c), ce === "{" ? Xt(c, u) || $ : p(u, 10, rt(c))) : (C === 7 && w(G.INVALID_LINKED_FORMAT, r(), 0), u.braceNest = 0, u.inLinked = !1, zt(c, u));
    }
  }
  function zt(c, u) {
    let C = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return Xt(c, u) || x(u);
    if (u.inLinked)
      return yt(c, u) || x(u);
    switch (c.currentChar()) {
      case "{":
        return Xt(c, u) || x(u);
      case "}":
        return w(G.UNBALANCED_CLOSING_BRACE, r(), 0), c.next(), p(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return yt(c, u) || x(u);
      default: {
        if (V(c))
          return C = p(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, C;
        if (q(c))
          return p(u, 0, le(c));
        break;
      }
    }
    return C;
  }
  function Un() {
    const { currentType: c, offset: u, startLoc: C, endLoc: $ } = i;
    return i.lastType = c, i.lastOffset = u, i.lastStartLoc = C, i.lastEndLoc = $, i.offset = s(), i.startLoc = r(), o.currentChar() === at ? p(
      i,
      13
      /* TokenTypes.EOF */
    ) : zt(o, i);
  }
  return {
    nextToken: Un,
    currentOffset: s,
    currentPosition: r,
    context: d
  };
}
const Pa = "parser", $a = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, Ma = /\\([\\@{}|])/g;
function Ra(e, t) {
  return t;
}
function Fa(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function Ua(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(m, f, T, _, ...N) {
    const O = m.currentPosition();
    if (O.offset += _, O.column += _, n) {
      const E = t ? Xn(T, O) : null, K = Yt(f, E, {
        domain: Pa,
        args: N
      });
      n(K);
    }
  }
  function s(m, f, T) {
    const _ = { type: m };
    return t && (_.start = f, _.end = f, _.loc = { start: T, end: T }), _;
  }
  function r(m, f, T, _) {
    t && (m.end = f, m.loc && (m.loc.end = T));
  }
  function a(m, f) {
    const T = m.context(), _ = s(3, T.offset, T.startLoc);
    return _.value = f.replace(Ma, Ra), r(_, m.currentOffset(), m.currentPosition()), _;
  }
  function l(m, f) {
    const T = m.context(), { lastOffset: _, lastStartLoc: N } = T, O = s(5, _, N);
    return O.index = parseInt(f, 10), m.nextToken(), r(O, m.currentOffset(), m.currentPosition()), O;
  }
  function i(m, f) {
    const T = m.context(), { lastOffset: _, lastStartLoc: N } = T, O = s(4, _, N);
    return O.key = f, m.nextToken(), r(O, m.currentOffset(), m.currentPosition()), O;
  }
  function d(m, f) {
    const T = m.context(), { lastOffset: _, lastStartLoc: N } = T, O = s(9, _, N);
    return O.value = f.replace($a, Fa), m.nextToken(), r(O, m.currentOffset(), m.currentPosition()), O;
  }
  function h(m) {
    const f = m.nextToken(), T = m.context(), { lastOffset: _, lastStartLoc: N } = T, O = s(8, _, N);
    return f.type !== 11 ? (o(m, G.UNEXPECTED_EMPTY_LINKED_MODIFIER, T.lastStartLoc, 0), O.value = "", r(O, _, N), {
      nextConsumeToken: f,
      node: O
    }) : (f.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, Qe(f)), O.value = f.value || "", r(O, m.currentOffset(), m.currentPosition()), {
      node: O
    });
  }
  function w(m, f) {
    const T = m.context(), _ = s(7, T.offset, T.startLoc);
    return _.value = f, r(_, m.currentOffset(), m.currentPosition()), _;
  }
  function p(m) {
    const f = m.context(), T = s(6, f.offset, f.startLoc);
    let _ = m.nextToken();
    if (_.type === 8) {
      const N = h(m);
      T.modifier = N.node, _ = N.nextConsumeToken || m.nextToken();
    }
    switch (_.type !== 9 && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(_)), _ = m.nextToken(), _.type === 2 && (_ = m.nextToken()), _.type) {
      case 10:
        _.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(_)), T.key = w(m, _.value || "");
        break;
      case 4:
        _.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(_)), T.key = i(m, _.value || "");
        break;
      case 5:
        _.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(_)), T.key = l(m, _.value || "");
        break;
      case 6:
        _.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(_)), T.key = d(m, _.value || "");
        break;
      default: {
        o(m, G.UNEXPECTED_EMPTY_LINKED_KEY, f.lastStartLoc, 0);
        const N = m.context(), O = s(7, N.offset, N.startLoc);
        return O.value = "", r(O, N.offset, N.startLoc), T.key = O, r(T, N.offset, N.startLoc), {
          nextConsumeToken: _,
          node: T
        };
      }
    }
    return r(T, m.currentOffset(), m.currentPosition()), {
      node: T
    };
  }
  function x(m) {
    const f = m.context(), T = f.currentType === 1 ? m.currentOffset() : f.offset, _ = f.currentType === 1 ? f.endLoc : f.startLoc, N = s(2, T, _);
    N.items = [];
    let O = null;
    do {
      const j = O || m.nextToken();
      switch (O = null, j.type) {
        case 0:
          j.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(j)), N.items.push(a(m, j.value || ""));
          break;
        case 5:
          j.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(j)), N.items.push(l(m, j.value || ""));
          break;
        case 4:
          j.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(j)), N.items.push(i(m, j.value || ""));
          break;
        case 6:
          j.value == null && o(m, G.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, Qe(j)), N.items.push(d(m, j.value || ""));
          break;
        case 7: {
          const V = p(m);
          N.items.push(V.node), O = V.nextConsumeToken || null;
          break;
        }
      }
    } while (f.currentType !== 13 && f.currentType !== 1);
    const E = f.currentType === 1 ? f.lastOffset : m.currentOffset(), K = f.currentType === 1 ? f.lastEndLoc : m.currentPosition();
    return r(N, E, K), N;
  }
  function A(m, f, T, _) {
    const N = m.context();
    let O = _.items.length === 0;
    const E = s(1, f, T);
    E.cases = [], E.cases.push(_);
    do {
      const K = x(m);
      O || (O = K.items.length === 0), E.cases.push(K);
    } while (N.currentType !== 13);
    return O && o(m, G.MUST_HAVE_MESSAGES_IN_PLURAL, T, 0), r(E, m.currentOffset(), m.currentPosition()), E;
  }
  function y(m) {
    const f = m.context(), { offset: T, startLoc: _ } = f, N = x(m);
    return f.currentType === 13 ? N : A(m, T, _, N);
  }
  function k(m) {
    const f = Da(m, _e({}, e)), T = f.context(), _ = s(0, T.offset, T.startLoc);
    return t && _.loc && (_.loc.source = m), _.body = y(f), e.onCacheKey && (_.cacheKey = e.onCacheKey(m)), T.currentType !== 13 && o(f, G.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, m[T.offset] || ""), r(_, f.currentOffset(), f.currentPosition()), _;
  }
  return { parse: k };
}
function Qe(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Ba(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Wo(e, t) {
  for (let n = 0; n < e.length; n++)
    po(e[n], t);
}
function po(e, t) {
  switch (e.type) {
    case 1:
      Wo(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Wo(e.items, t);
      break;
    case 6: {
      po(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Va(e, t = {}) {
  const n = Ba(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && po(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function Ha(e) {
  const t = e.body;
  return t.type === 2 ? Go(t) : t.cases.forEach((n) => Go(n)), e;
}
function Go(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = mo(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const Ya = "minifier";
function $t(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      $t(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        $t(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        $t(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      $t(t.key), t.k = t.key, delete t.key, t.modifier && ($t(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Yt(G.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Ya,
          args: [e.type]
        });
  }
  delete e.type;
}
const ja = "parser";
function Wa(e, t) {
  const { filename: n, breakLineCode: o, needIndent: s } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const l = () => a;
  function i(y, k) {
    a.code += y;
  }
  function d(y, k = !0) {
    const m = k ? o : "";
    i(s ? m + "  ".repeat(y) : m);
  }
  function h(y = !0) {
    const k = ++a.indentLevel;
    y && d(k);
  }
  function w(y = !0) {
    const k = --a.indentLevel;
    y && d(k);
  }
  function p() {
    d(a.indentLevel);
  }
  return {
    context: l,
    push: i,
    indent: h,
    deindent: w,
    newline: p,
    helper: (y) => `_${y}`,
    needIndent: () => a.needIndent
  };
}
function Ga(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ut(e, t.key), t.modifier ? (e.push(", "), Ut(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Ka(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const s = t.items.length;
  for (let r = 0; r < s && (Ut(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function qa(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const s = t.cases.length;
    for (let r = 0; r < s && (Ut(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function Xa(e, t) {
  t.body ? Ut(e, t.body) : e.push("null");
}
function Ut(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Xa(e, t);
      break;
    case 1:
      qa(e, t);
      break;
    case 2:
      Ka(e, t);
      break;
    case 6:
      Ga(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Yt(G.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: ja,
          args: [t.type]
        });
  }
}
const za = (e, t = {}) => {
  const n = M(t.mode) ? t.mode : "normal", o = M(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], l = Wa(e, {
    filename: o,
    breakLineCode: s,
    needIndent: r
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(r), a.length > 0 && (l.push(`const { ${mo(a.map((h) => `${h}: _${h}`), ", ")} } = ctx`), l.newline()), l.push("return "), Ut(l, e), l.deindent(r), l.push("}"), delete e.helpers;
  const { code: i, map: d } = l.context();
  return {
    ast: e,
    code: i,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ja(e, t = {}) {
  const n = _e({}, t), o = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, l = Ua(n).parse(e);
  return o ? (r && Ha(l), s && $t(l), { ast: l, code: "" }) : (Va(l, n), za(l, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Za() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Xe(e) {
  return Z(e) && ho(e) === 0 && (Ye(e, "b") || Ye(e, "body"));
}
const Is = ["b", "body"];
function Qa(e) {
  return vt(e, Is);
}
const Ss = ["c", "cases"];
function ei(e) {
  return vt(e, Ss, []);
}
const Ds = ["s", "static"];
function ti(e) {
  return vt(e, Ds);
}
const Ps = ["i", "items"];
function ni(e) {
  return vt(e, Ps, []);
}
const $s = ["t", "type"];
function ho(e) {
  return vt(e, $s);
}
const Ms = ["v", "value"];
function fn(e, t) {
  const n = vt(e, Ms);
  if (n != null)
    return n;
  throw Zt(t);
}
const Rs = ["m", "modifier"];
function oi(e) {
  return vt(e, Rs);
}
const Fs = ["k", "key"];
function si(e) {
  const t = vt(e, Fs);
  if (t)
    return t;
  throw Zt(
    6
    /* NodeTypes.Linked */
  );
}
function vt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (Ye(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Us = [
  ...Is,
  ...Ss,
  ...Ds,
  ...Ps,
  ...Fs,
  ...Rs,
  ...Ms,
  ...$s
];
function Zt(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Vn(e) {
  return (n) => ri(n, e);
}
function ri(e, t) {
  const n = Qa(t);
  if (n == null)
    throw Zt(
      0
      /* NodeTypes.Resource */
    );
  if (ho(n) === 1) {
    const r = ei(n);
    return e.plural(r.reduce((a, l) => [
      ...a,
      Ko(e, l)
    ], []));
  } else
    return Ko(e, n);
}
function Ko(e, t) {
  const n = ti(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = ni(t).reduce((s, r) => [...s, zn(e, r)], []);
    return e.normalize(o);
  }
}
function zn(e, t) {
  const n = ho(t);
  switch (n) {
    case 3:
      return fn(t, n);
    case 9:
      return fn(t, n);
    case 4: {
      const o = t;
      if (Ye(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Ye(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Zt(n);
    }
    case 5: {
      const o = t;
      if (Ye(o, "i") && ke(o.i))
        return e.interpolate(e.list(o.i));
      if (Ye(o, "index") && ke(o.index))
        return e.interpolate(e.list(o.index));
      throw Zt(n);
    }
    case 6: {
      const o = t, s = oi(o), r = si(o);
      return e.linked(zn(e, r), s ? zn(e, s) : void 0, e.type);
    }
    case 7:
      return fn(t, n);
    case 8:
      return fn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const ai = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function ii(e, t) {
  t && Ta(e) && nt(On(ai, { source: e }));
}
const li = (e) => e;
let mn = ae();
function ci(e, t = {}) {
  let n = !1;
  const o = t.onError || xa;
  return t.onError = (s) => {
    n = !0, o(s);
  }, { ...Ja(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function ui(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && M(e)) {
    const n = he(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && ii(e, n);
    const s = (t.onCacheKey || li)(e), r = mn[s];
    if (r)
      return r;
    const { ast: a, detectError: l } = ci(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), i = Vn(a);
    return l ? i : mn[s] = i;
  } else {
    if (process.env.NODE_ENV !== "production" && !Xe(e))
      return nt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = mn[n];
      return o || (mn[n] = Vn(e));
    } else
      return Vn(e);
  }
}
let Qt = null;
function di(e) {
  Qt = e;
}
function fi(e, t, n) {
  Qt && Qt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const mi = /* @__PURE__ */ pi("function:translate");
function pi(e) {
  return (t) => Qt && Qt.emit(e, t);
}
const Ae = {
  INVALID_ARGUMENT: Ea,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, hi = 24;
function lt(e) {
  return Yt(e, null, process.env.NODE_ENV !== "production" ? { messages: gi } : void 0);
}
const gi = {
  [Ae.INVALID_ARGUMENT]: "Invalid arguments",
  [Ae.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ae.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ae.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ae.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ae.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ae.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function go(e, t) {
  return t.locale != null ? qo(t.locale) : qo(e.locale);
}
let Hn;
function qo(e) {
  if (M(e))
    return e;
  if (ue(e)) {
    if (e.resolvedOnce && Hn != null)
      return Hn;
    if (e.constructor.name === "Function") {
      const t = e();
      if (ba(t))
        throw lt(Ae.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Hn = t;
    } else
      throw lt(Ae.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw lt(Ae.NOT_SUPPORT_LOCALE_TYPE);
}
function wi(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...ge(t) ? t : Z(t) ? Object.keys(t) : M(t) ? [t] : [n]
  ])];
}
function Jn(e, t, n) {
  const o = M(n) ? n : bn, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; ge(a); )
      a = Xo(r, a, t);
    const l = ge(t) || !se(t) ? t : t.default ? t.default : null;
    a = M(l) ? [l] : l, ge(a) && Xo(r, a, !1), s.__localeChainCache.set(o, r);
  }
  return r;
}
function Xo(e, t, n) {
  let o = !0;
  for (let s = 0; s < t.length && he(o); s++) {
    const r = t[s];
    M(r) && (o = bi(e, t[s], n));
  }
  return o;
}
function bi(e, t, n) {
  let o;
  const s = t.split("-");
  do {
    const r = s.join("-");
    o = vi(e, r, n), s.splice(-1, 1);
  } while (s.length && o === !0);
  return o;
}
function vi(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (ge(n) || se(n)) && n[s] && (o = n[s]);
  }
  return o;
}
const _t = [];
_t[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_t[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_t[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
_t[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
_t[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
_t[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
_t[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const _i = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function yi(e) {
  return _i.test(e);
}
function Ei(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function ki(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function xi(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : yi(t) ? Ei(t) : "*" + t;
}
function Ci(e) {
  const t = [];
  let n = -1, o = 0, s = 0, r, a, l, i, d, h, w;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = l : a += l;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), s++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, o = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = xi(a), a === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function x() {
    const A = e[n + 1];
    if (o === 5 && A === "'" || o === 6 && A === '"')
      return n++, l = "\\" + A, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && x())) {
      if (i = ki(r), w = _t[o], d = w[i] || w.l || 8, d === 8 || (o = d[0], d[1] !== void 0 && (h = p[d[1]], h && (l = r, h() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const zo = /* @__PURE__ */ new Map();
function Ti(e, t) {
  return Z(e) ? e[t] : null;
}
function Li(e, t) {
  if (!Z(e))
    return null;
  let n = zo.get(t);
  if (n || (n = Ci(t), n && zo.set(t, n)), !n)
    return null;
  const o = n.length;
  let s = e, r = 0;
  for (; r < o; ) {
    const a = n[r];
    if (Us.includes(a) && Xe(s) || !Z(s) || !Ye(s, a))
      return null;
    const l = s[a];
    if (l === void 0 || ue(s))
      return null;
    s = l, r++;
  }
  return s;
}
const Ee = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, Pt = 10, Ni = {
  [Ee.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ee.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ee.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ee.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [Ee.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [Ee.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function ct(e, ...t) {
  return On(Ni[e], ...t);
}
const Ai = "11.4.4", Sn = -1, bn = "en-US", Bt = "", Jo = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Oi() {
  return {
    upper: (e, t) => t === "text" && M(e) ? e.toUpperCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && M(e) ? e.toLowerCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && M(e) ? Jo(e) : t === "vnode" && Z(e) && "__v_isVNode" in e ? Jo(e.children) : e
  };
}
let Bs;
function Ii(e) {
  Bs = e;
}
let Vs;
function Si(e) {
  Vs = e;
}
let Hs;
function Di(e) {
  Hs = e;
}
let Ys = null;
const Pi = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Ys = e;
}, $i = /* @__NO_SIDE_EFFECTS__ */ () => Ys;
let js = null;
const Zo = (e) => {
  js = e;
}, Mi = () => js;
let Qo = 0;
function Ri(e = {}) {
  const t = ue(e.onWarn) ? e.onWarn : nt, n = M(e.version) ? e.version : Ai, o = M(e.locale) || ue(e.locale) ? e.locale : bn, s = ue(o) ? bn : o, r = ge(e.fallbackLocale) || se(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, a = se(e.messages) ? e.messages : Yn(s), l = se(e.datetimeFormats) ? e.datetimeFormats : Yn(s), i = se(e.numberFormats) ? e.numberFormats : Yn(s), d = _e(ae(), e.modifiers, Oi()), h = e.pluralRules || ae(), w = ue(e.missing) ? e.missing : null, p = he(e.missingWarn) || wn(e.missingWarn) ? e.missingWarn : !0, x = he(e.fallbackWarn) || wn(e.fallbackWarn) ? e.fallbackWarn : !0, A = !!e.fallbackFormat, y = !!e.unresolving, k = ue(e.postTranslation) ? e.postTranslation : null, m = se(e.processor) ? e.processor : null, f = he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter, _ = ue(e.messageCompiler) ? e.messageCompiler : Bs;
  process.env.NODE_ENV !== "production" && ue(e.messageCompiler) && ia(ct(Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const N = ue(e.messageResolver) ? e.messageResolver : Vs || Ti, O = ue(e.localeFallbacker) ? e.localeFallbacker : Hs || wi, E = Z(e.fallbackContext) ? e.fallbackContext : void 0, K = e, j = Z(K.__datetimeFormatters) ? K.__datetimeFormatters : /* @__PURE__ */ new Map(), V = Z(K.__numberFormatters) ? K.__numberFormatters : /* @__PURE__ */ new Map(), q = Z(K.__meta) ? K.__meta : {};
  Qo++;
  const U = {
    version: n,
    cid: Qo,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: d,
    pluralRules: h,
    missing: w,
    missingWarn: p,
    fallbackWarn: x,
    fallbackFormat: A,
    unresolving: y,
    postTranslation: k,
    processor: m,
    warnHtmlMessage: f,
    escapeParameter: T,
    messageCompiler: _,
    messageResolver: N,
    localeFallbacker: O,
    fallbackContext: E,
    onWarn: t,
    __meta: q
  };
  return U.datetimeFormats = l, U.numberFormats = i, U.__datetimeFormatters = j, U.__numberFormatters = V, process.env.NODE_ENV !== "production" && (U.__v_emitter = K.__v_emitter != null ? K.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && fi(U, n, q), U;
}
const Yn = (e) => ({ [e]: ae() });
function Dn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ws(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function wo(e, t, n, o, s) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const l = e.__v_emitter;
    l && l.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const l = r(e, n, t, s);
    return M(l) ? l : t;
  } else
    return process.env.NODE_ENV !== "production" && Ws(o, t) && a(ct(Ee.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Jt(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Gs(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Fi(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (Gs(e, t[o]))
      return !0;
  return !1;
}
const es = typeof Intl < "u", Ks = {
  dateTimeFormat: es && typeof Intl.DateTimeFormat < "u",
  numberFormat: es && typeof Intl.NumberFormat < "u"
};
function ts(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !Ks.dateTimeFormat)
    return r(ct(Ee.CANNOT_FORMAT_DATE)), Bt;
  if (!M(t[0]) && !Ns(t[0]) && !ke(t[0]))
    return process.env.NODE_ENV !== "production" && r(ct(Ee.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), Bt;
  const [i, d, h, w] = Zn(...t), p = he(h.missingWarn) ? h.missingWarn : e.missingWarn, x = he(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, A = !!h.part, y = go(e, h), k = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    y
  );
  if (!M(i) || i === "")
    return new Intl.DateTimeFormat(y.replace(/!/g, ""), w).format(d);
  let m = {}, f, T = null, _ = y, N = null;
  const O = "datetime format";
  for (let j = 0; j < k.length; j++) {
    if (f = N = k[j], process.env.NODE_ENV !== "production" && y !== f && Dn(x, i) && r(ct(Ee.FALLBACK_TO_DATE_FORMAT, {
      key: i,
      target: f
    })), process.env.NODE_ENV !== "production" && y !== f) {
      const V = e.__v_emitter;
      V && V.emit("fallback", {
        type: O,
        key: i,
        from: _,
        to: N,
        groupId: `${O}:${i}`
      });
    }
    if (m = n[f] || {}, T = m[i], se(T))
      break;
    wo(e, i, f, p, O), _ = N;
  }
  if (!se(T) || !M(f))
    return o ? Sn : i;
  let E = `${f}__${i}`;
  In(w) || (E = `${E}__${JSON.stringify(w)}`);
  let K = l.get(E);
  return K || (K = new Intl.DateTimeFormat(f, _e({}, T, w)), l.set(E, K)), A ? K.formatToParts(d) : K.format(d);
}
const qs = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Zn(...e) {
  const [t, n, o, s] = e, r = ae();
  let a = ae(), l;
  if (M(t)) {
    const i = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!i)
      throw lt(Ae.INVALID_ISO_DATE_ARGUMENT);
    const d = i[3] ? i[3].trim().startsWith("T") ? `${i[1].trim()}${i[3].trim()}` : `${i[1].trim()}T${i[3].trim()}` : i[1].trim();
    l = new Date(d);
    try {
      l.toISOString();
    } catch {
      throw lt(Ae.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Ns(t)) {
    if (isNaN(t.getTime()))
      throw lt(Ae.INVALID_DATE_ARGUMENT);
    l = t;
  } else if (ke(t))
    l = t;
  else
    throw lt(Ae.INVALID_ARGUMENT);
  return M(n) ? r.key = n : se(n) && Object.keys(n).forEach((i) => {
    qs.includes(i) ? a[i] = n[i] : r[i] = n[i];
  }), M(o) ? r.locale = o : se(o) && (a = o), se(s) && (a = s), [r.key || "", l, r, a];
}
function ns(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function os(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !Ks.numberFormat)
    return r(ct(Ee.CANNOT_FORMAT_NUMBER)), Bt;
  if (!ke(t[0]))
    return process.env.NODE_ENV !== "production" && r(ct(Ee.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), Bt;
  const [i, d, h, w] = Qn(...t), p = he(h.missingWarn) ? h.missingWarn : e.missingWarn, x = he(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, A = !!h.part, y = go(e, h), k = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    y
  );
  if (!M(i) || i === "")
    return new Intl.NumberFormat(y.replace(/!/g, ""), w).format(d);
  let m = {}, f, T = null, _ = y, N = null;
  const O = "number format";
  for (let j = 0; j < k.length; j++) {
    if (f = N = k[j], process.env.NODE_ENV !== "production" && y !== f && Dn(x, i) && r(ct(Ee.FALLBACK_TO_NUMBER_FORMAT, {
      key: i,
      target: f
    })), process.env.NODE_ENV !== "production" && y !== f) {
      const V = e.__v_emitter;
      V && V.emit("fallback", {
        type: O,
        key: i,
        from: _,
        to: N,
        groupId: `${O}:${i}`
      });
    }
    if (m = n[f] || {}, T = m[i], se(T))
      break;
    wo(e, i, f, p, O), _ = N;
  }
  if (!se(T) || !M(f))
    return o ? Sn : i;
  let E = `${f}__${i}`;
  In(w) || (E = `${E}__${JSON.stringify(w)}`);
  let K = l.get(E);
  return K || (K = new Intl.NumberFormat(f, _e({}, T, w)), l.set(E, K)), A ? K.formatToParts(d) : K.format(d);
}
const Xs = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Qn(...e) {
  const [t, n, o, s] = e, r = ae();
  let a = ae();
  if (!ke(t))
    throw lt(Ae.INVALID_ARGUMENT);
  const l = t;
  return M(n) ? r.key = n : se(n) && Object.keys(n).forEach((i) => {
    Xs.includes(i) ? a[i] = n[i] : r[i] = n[i];
  }), M(o) ? r.locale = o : se(o) && (a = o), se(s) && (a = s), [r.key || "", l, r, a];
}
function ss(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
const Ui = (e) => e, Bi = (e) => "", Vi = "text", Hi = (e) => e.length === 0 ? "" : mo(e), Yi = va;
function jn(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function ji(e) {
  var n, o;
  const t = ke(e.pluralIndex) ? e.pluralIndex : -1;
  return ke((n = e.named) == null ? void 0 : n.count) ? e.named.count : ke((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function Wi(e = {}) {
  var m, f, T, _;
  const t = e.locale, n = ji(e), o = M(t) && ue((m = e.pluralRules) == null ? void 0 : m[t]) ? e.pluralRules[t] : jn, s = o === jn ? void 0 : jn, r = (N) => N[o(n, N.length, s)], a = e.list || [], l = (N) => a[N], i = e.named || ae();
  ke(e.pluralIndex) && (i.count || (i.count = e.pluralIndex), i.n || (i.n = e.pluralIndex));
  const d = (N) => i[N];
  function h(N, O) {
    const E = ue(e.messages) ? e.messages(N, !!O) : Z(e.messages) ? e.messages[N] : !1;
    return E || (e.parent ? e.parent.message(N) : Bi);
  }
  const w = (N) => e.modifiers ? e.modifiers[N] : Ui, p = ue((f = e.processor) == null ? void 0 : f.normalize) ? e.processor.normalize : Hi, x = ue((T = e.processor) == null ? void 0 : T.interpolate) ? e.processor.interpolate : Yi, A = M((_ = e.processor) == null ? void 0 : _.type) ? e.processor.type : Vi, k = {
    list: l,
    named: d,
    plural: r,
    linked: (N, ...O) => {
      const [E, K] = O;
      let j = "text", V = "";
      O.length === 1 ? Z(E) ? (V = E.modifier || V, j = E.type || j) : M(E) && (V = E || V) : O.length === 2 && (M(E) && (V = E || V), M(K) && (j = K || j));
      const q = h(N, !0)(k), U = q === "" || q === void 0 ? N : q, ie = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        j === "vnode" && ge(U) && V ? U[0] : U
      );
      return V ? w(V)(ie, j) : ie;
    },
    message: h,
    type: A,
    interpolate: x,
    normalize: p,
    values: _e(ae(), a, i)
  };
  return k;
}
const rs = () => "", He = (e) => ue(e);
function as(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: l } = e, [i, d] = eo(...t), h = he(d.missingWarn) ? d.missingWarn : e.missingWarn, w = he(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, p = he(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, x = !!d.resolvedMessage, A = M(d.default) || he(d.default) ? he(d.default) ? r ? i : () => i : d.default : n ? r ? i : () => i : null, y = n || A != null && (M(A) || ue(A)), k = go(e, d);
  p && Gi(d);
  let [m, f, T] = x ? [
    i,
    k,
    l[k] || ae()
  ] : zs(e, i, k, a, w, h), _ = m, N = i;
  if (!x && !(M(_) || Xe(_) || He(_)) && y && (_ = A, N = _), !x && (!(M(_) || Xe(_) || He(_)) || !M(f)))
    return s ? Sn : i;
  if (process.env.NODE_ENV !== "production" && M(_) && e.messageCompiler == null)
    return nt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${i}'.`), i;
  let O = !1;
  const E = () => {
    O = !0;
  }, K = He(_) ? _ : Js(e, i, f, _, N, E);
  if (O)
    return _;
  const j = zi(e, f, T, d), V = Wi(j), q = Ki(e, K, V);
  let U = o ? o(q, i) : q;
  if (p && M(U) && (U = ga(U)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const ie = {
      timestamp: Date.now(),
      key: M(i) ? i : He(_) ? _.key : "",
      locale: f || (He(_) ? _.locale : ""),
      format: M(_) ? _ : He(_) ? _.source : "",
      message: U
    };
    ie.meta = _e({}, e.__meta, /* @__PURE__ */ $i() || {}), mi(ie);
  }
  return U;
}
function Gi(e) {
  ge(e.list) ? e.list = e.list.map((t) => M(t) ? Vo(t) : t) : Z(e.named) && Object.keys(e.named).forEach((t) => {
    M(e.named[t]) && (e.named[t] = Vo(e.named[t]));
  });
}
function zs(e, t, n, o, s, r) {
  const { messages: a, onWarn: l, messageResolver: i, localeFallbacker: d } = e, h = d(e, o, n);
  let w = ae(), p, x = null, A = n, y = null;
  const k = "translate";
  for (let m = 0; m < h.length; m++) {
    p = y = h[m], process.env.NODE_ENV !== "production" && n !== p && !Gs(n, p) && Dn(s, t) && l(ct(Ee.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    }));
    const f = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== p && f && f.emit("fallback", {
      type: k,
      key: t,
      from: A,
      to: y,
      groupId: `${k}:${t}`
    }), w = a[p] || ae();
    let T = null, _, N;
    if (process.env.NODE_ENV !== "production" && dt && f && (T = window.performance.now(), _ = "intlify-message-resolve-start", N = "intlify-message-resolve-end", Me && Me(_)), (x = i(w, t)) === null && (x = w[t]), process.env.NODE_ENV !== "production" && dt && f) {
      const O = window.performance.now();
      f && T && x && f.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: x,
        time: O - T,
        groupId: `${k}:${t}`
      }), _ && N && Me && Ot && (Me(N), Ot("intlify message resolve", _, N));
    }
    if (M(x) || Xe(x) || He(x))
      break;
    if (!Fi(p, h)) {
      const O = wo(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        r,
        k
      );
      O !== t && (x = O);
    }
    A = y;
  }
  return [x, p, w];
}
function Js(e, t, n, o, s, r) {
  const { messageCompiler: a, warnHtmlMessage: l } = e;
  if (He(o)) {
    const x = o;
    return x.locale = x.locale || n, x.key = x.key || t, x;
  }
  if (a == null) {
    const x = () => o;
    return x.locale = n, x.key = t, x;
  }
  const i = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let d = null, h, w;
  process.env.NODE_ENV !== "production" && dt && i && (d = window.performance.now(), h = "intlify-message-compilation-start", w = "intlify-message-compilation-end", Me && Me(h));
  const p = a(o, qi(e, n, s, o, l, r));
  if (process.env.NODE_ENV !== "production" && dt && i) {
    const x = window.performance.now();
    i && d && i.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: x - d,
      groupId: `translate:${t}`
    }), h && w && Me && Ot && (Me(w), Ot("intlify message compilation", h, w));
  }
  return p.locale = n, p.key = t, p.source = o, p;
}
function Ki(e, t, n) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let s = null, r, a;
  process.env.NODE_ENV !== "production" && dt && o && (s = window.performance.now(), r = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", Me && Me(r));
  const l = t(n);
  if (process.env.NODE_ENV !== "production" && dt && o) {
    const i = window.performance.now();
    o && s && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - s,
      groupId: `translate:${t.key}`
    }), r && a && Me && Ot && (Me(a), Ot("intlify message evaluation", r, a));
  }
  return l;
}
function eo(...e) {
  const [t, n, o] = e, s = ae();
  if (!M(t) && !ke(t) && !He(t) && !Xe(t))
    throw lt(Ae.INVALID_ARGUMENT);
  const r = ke(t) ? String(t) : (He(t), t);
  return ke(n) ? s.plural = n : M(n) ? s.default = n : se(n) && !In(n) ? s.named = n : ge(n) && (s.list = n), ke(o) ? s.plural = o : M(o) ? s.default = o : se(o) && _e(s, o), [r, s];
}
function qi(e, t, n, o, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const l = Xi(o), i = a.location && l && _a(l, a.location.start.offset, a.location.end.offset), d = e.__v_emitter;
        d && l && d.emit("compile-error", {
          message: l,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const h = `Message compilation error: ${a.message}`;
        throw new SyntaxError(i ? `${h}
${i}` : h);
      }
      throw a;
    },
    onCacheKey: (a) => ca(t, n, a)
  };
}
function Xi(e) {
  if (M(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function zi(e, t, n, o) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: l, fallbackWarn: i, missingWarn: d, fallbackContext: h } = e, p = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (x, A) => {
      let y = a(n, x);
      if (y == null && (h || A)) {
        const [k, , m] = zs(
          h || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          x,
          t,
          l,
          i,
          d
        );
        y = k ?? a(m, x);
      }
      if (M(y) || Xe(y)) {
        let k = !1;
        const f = Js(e, x, t, y, x, () => {
          k = !0;
        });
        return k ? rs : f;
      } else return He(y) ? y : rs;
    }
  };
  return e.processor && (p.processor = e.processor), o.list && (p.list = o.list), o.named && (p.named = o.named), ke(o.plural) && (p.pluralIndex = o.plural), p;
}
Za();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ji = "11.4.4";
function Zi() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Nt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Nt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ye = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: hi,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Rt(e, ...t) {
  return Yt(e, null, process.env.NODE_ENV !== "production" ? { messages: Qi, args: t } : void 0);
}
const Qi = {
  [ye.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ye.INVALID_ARGUMENT]: "Invalid argument",
  [ye.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ye.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ye.UNEXPECTED_ERROR]: "Unexpected error",
  [ye.REQUIRED_VALUE]: "Required in value: {0}",
  [ye.INVALID_VALUE]: "Invalid value",
  [ye.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ye.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ye.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ye.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, to = /* @__PURE__ */ mt("__translateVNode"), no = /* @__PURE__ */ mt("__datetimeParts"), oo = /* @__PURE__ */ mt("__numberParts"), en = /* @__PURE__ */ mt("__enableEmitter"), tn = /* @__PURE__ */ mt("__disableEmitter"), el = mt("__setPluralRules"), Zs = /* @__PURE__ */ mt("__injectWithOption"), Mt = /* @__PURE__ */ mt("__dispose"), tt = {
  FALLBACK_TO_ROOT: Pt,
  // 10
  NOT_FOUND_PARENT_SCOPE: Pt + 1,
  IGNORE_OBJ_FLATTEN: Pt + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: Pt + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: Pt + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: Pt + 5
}, tl = {
  [tt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [tt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [tt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [tt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [tt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [tt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function vn(e, ...t) {
  return On(tl[e], ...t);
}
function nn(e) {
  if (!Z(e) || Xe(e))
    return e;
  for (const t in e)
    if (Ye(e, t))
      if (!t.includes("."))
        Z(e[t]) && nn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let s = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in s || (s[n[a]] = ae()), !Z(s[n[a]])) {
            process.env.NODE_ENV !== "production" && nt(vn(tt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          s = s[n[a]];
        }
        if (r || (Xe(s) ? Us.includes(n[o]) || delete e[t] : (s[n[o]] = e[t], delete e[t])), !Xe(s)) {
          const a = s[n[o]];
          Z(a) && nn(a);
        }
      }
  return e;
}
function Qs(e, t) {
  const { messages: n, __i18n: o, messageResolver: s, flatJson: r } = t, a = se(n) ? n : ge(o) ? ae() : { [e]: ae() };
  if (ge(o) && o.forEach((l) => {
    if ("locale" in l && "resource" in l) {
      const { locale: i, resource: d } = l;
      i ? (a[i] = a[i] || ae(), hn(d, a[i])) : hn(d, a);
    } else
      M(l) && hn(JSON.parse(l), a);
  }), s == null && r)
    for (const l in a)
      Ye(a, l) && nn(a[l]);
  return a;
}
function er(e) {
  return e.type;
}
function nl(e, t, n) {
  let o = Z(t.messages) ? t.messages : ae();
  "__i18nGlobal" in n && (o = Qs(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(o);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (Z(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (Z(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function is(e) {
  return Tt(ra, null, e, 0);
}
function bo() {
  const e = "currentInstance";
  return e in Bn ? Bn[e] : Bn.getCurrentInstance();
}
const ls = "__INTLIFY_META__", cs = () => [], ol = () => !1;
let us = 0;
function ds(e) {
  return (t, n, o, s) => e(n, o, bo() || void 0, s);
}
const sl = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = bo();
  let t = null;
  return e && (t = er(e)[ls]) ? { [ls]: t } : null;
};
function fs(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, s = e.flatJson, r = dt ? J : sa;
  let a = he(e.inheritLocale) ? e.inheritLocale : !0;
  const l = r(
    // prettier-ignore
    t && a ? t.locale.value : M(e.locale) ? e.locale : bn
  ), i = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : M(e.fallbackLocale) || ge(e.fallbackLocale) || se(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : l.value
  ), d = r(Qs(l.value, e)), h = r(se(e.datetimeFormats) ? e.datetimeFormats : { [l.value]: {} }), w = r(se(e.numberFormats) ? e.numberFormats : { [l.value]: {} });
  let p = t ? t.missingWarn : he(e.missingWarn) || wn(e.missingWarn) ? e.missingWarn : !0, x = t ? t.fallbackWarn : he(e.fallbackWarn) || wn(e.fallbackWarn) ? e.fallbackWarn : !0, A = t ? t.fallbackRoot : he(e.fallbackRoot) ? e.fallbackRoot : !0, y = !!e.fallbackFormat, k = ue(e.missing) ? e.missing : null, m = ue(e.missing) ? ds(e.missing) : null, f = ue(e.postTranslation) ? e.postTranslation : null, T = t ? t.warnHtmlMessage : he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter;
  const N = t ? t.modifiers : se(e.modifiers) ? e.modifiers : {};
  let O = e.pluralRules || t && t.pluralRules, E;
  E = (() => {
    o && Zo(null);
    const v = {
      version: Ji,
      locale: l.value,
      fallbackLocale: i.value,
      messages: d.value,
      modifiers: N,
      pluralRules: O,
      missing: m === null ? void 0 : m,
      missingWarn: p,
      fallbackWarn: x,
      fallbackFormat: y,
      unresolving: !0,
      postTranslation: f === null ? void 0 : f,
      warnHtmlMessage: T,
      escapeParameter: _,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    v.datetimeFormats = h.value, v.numberFormats = w.value, v.__datetimeFormatters = se(E) ? E.__datetimeFormatters : void 0, v.__numberFormatters = se(E) ? E.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (v.__v_emitter = se(E) ? E.__v_emitter : void 0);
    const L = Ri(v);
    return o && Zo(L), L;
  })(), Jt(E, l.value, i.value);
  function j() {
    return [
      l.value,
      i.value,
      d.value,
      h.value,
      w.value
    ];
  }
  const V = Ne({
    get: () => l.value,
    set: (v) => {
      E.locale = v, l.value = v;
    }
  }), q = Ne({
    get: () => i.value,
    set: (v) => {
      E.fallbackLocale = v, i.value = v, Jt(E, l.value, v);
    }
  }), U = Ne(() => d.value), ie = /* @__PURE__ */ Ne(() => h.value), S = /* @__PURE__ */ Ne(() => w.value);
  function I() {
    return ue(f) ? f : null;
  }
  function D(v) {
    f = v, E.postTranslation = v;
  }
  function F() {
    return k;
  }
  function P(v) {
    v !== null && (m = ds(v)), k = v, E.missing = m;
  }
  function X(v, L) {
    return v !== "translate" || !L.resolvedMessage;
  }
  const B = (v, L, te, fe, Et, kt) => {
    j();
    let Ve;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = t ? Mi() : void 0), Ve = v(E);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = void 0);
    }
    if (te !== "translate exists" && // for not `te` (e.g `t`)
    ke(Ve) && Ve === Sn || te === "translate exists" && !Ve) {
      const [xt, Qr] = L();
      if (process.env.NODE_ENV !== "production" && t && M(xt) && X(te, Qr) && (A && (Dn(x, xt) || Ws(p, xt)) && nt(vn(tt.FALLBACK_TO_ROOT, {
        key: xt,
        type: te
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Fo } = E;
        Fo && A && Fo.emit("fallback", {
          type: te,
          key: xt,
          to: "global",
          groupId: `${te}:${xt}`
        });
      }
      return t && A ? fe(t) : Et(xt);
    } else {
      if (kt(Ve))
        return Ve;
      throw Rt(ye.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Q(...v) {
    return B((L) => Reflect.apply(as, null, [L, ...v]), () => eo(...v), "translate", (L) => Reflect.apply(L.t, L, [...v]), (L) => L, (L) => M(L));
  }
  function le(...v) {
    const [L, te, fe] = v;
    if (fe && !Z(fe))
      throw Rt(ye.INVALID_ARGUMENT);
    return Q(L, te, _e({ resolvedMessage: !0 }, fe || {}));
  }
  function de(...v) {
    return B((L) => Reflect.apply(ts, null, [L, ...v]), () => Zn(...v), "datetime format", (L) => Reflect.apply(L.d, L, [...v]), () => Bt, (L) => M(L) || ge(L));
  }
  function be(...v) {
    return B((L) => Reflect.apply(os, null, [L, ...v]), () => Qn(...v), "number format", (L) => Reflect.apply(L.n, L, [...v]), () => Bt, (L) => M(L) || ge(L));
  }
  function Te(v) {
    return v.map((L) => M(L) || ke(L) || he(L) ? is(String(L)) : L);
  }
  const We = {
    normalize: Te,
    interpolate: (v) => v,
    type: "vnode"
  };
  function ze(...v) {
    return B((L) => {
      let te;
      const fe = L;
      try {
        fe.processor = We, te = Reflect.apply(as, null, [fe, ...v]);
      } finally {
        fe.processor = null;
      }
      return te;
    }, () => eo(...v), "translate", (L) => L[to](...v), (L) => [is(L)], (L) => ge(L));
  }
  function Ge(...v) {
    return B((L) => Reflect.apply(os, null, [L, ...v]), () => Qn(...v), "number format", (L) => L[oo](...v), cs, (L) => M(L) || ge(L));
  }
  function ve(...v) {
    return B((L) => Reflect.apply(ts, null, [L, ...v]), () => Zn(...v), "datetime format", (L) => L[no](...v), cs, (L) => M(L) || ge(L));
  }
  function Be(v) {
    O = v, E.pluralRules = O;
  }
  function rt(v, L) {
    return B(() => {
      if (!v)
        return !1;
      const te = M(L) ? L : l.value, fe = M(L) ? [te] : Jn(E, i.value, te);
      for (let Et = 0; Et < fe.length; Et++) {
        const kt = yt(fe[Et]);
        let Ve = E.messageResolver(kt, v);
        if (Ve === null && (Ve = kt[v]), Xe(Ve) || He(Ve) || M(Ve))
          return !0;
      }
      return !1;
    }, () => [v], "translate exists", (te) => Reflect.apply(te.te, te, [v, L]), ol, (te) => he(te));
  }
  function Je(v) {
    let L = null;
    const te = Jn(E, i.value, l.value);
    for (let fe = 0; fe < te.length; fe++) {
      const Et = d.value[te[fe]] || {}, kt = E.messageResolver(Et, v);
      if (kt != null) {
        L = kt;
        break;
      }
    }
    return L;
  }
  function Xt(v) {
    const L = Je(v);
    return L ?? (t ? t.tm(v) || {} : {});
  }
  function yt(v) {
    return d.value[v] || {};
  }
  function zt(v, L) {
    if (s) {
      const te = { [v]: L };
      for (const fe in te)
        Ye(te, fe) && nn(te[fe]);
      L = te[v];
    }
    d.value[v] = L, E.messages = d.value;
  }
  function Un(v, L) {
    d.value[v] = d.value[v] || {};
    const te = { [v]: L };
    if (s)
      for (const fe in te)
        Ye(te, fe) && nn(te[fe]);
    L = te[v], hn(L, d.value[v]), E.messages = d.value;
  }
  function c(v) {
    return h.value[v] || {};
  }
  function u(v, L) {
    h.value[v] = L, E.datetimeFormats = h.value, ns(E, v, L);
  }
  function C(v, L) {
    h.value[v] = _e(h.value[v] || {}, L), E.datetimeFormats = h.value, ns(E, v, L);
  }
  function $(v) {
    return w.value[v] || {};
  }
  function ce(v, L) {
    w.value[v] = L, E.numberFormats = w.value, ss(E, v, L);
  }
  function me(v, L) {
    w.value[v] = _e(w.value[v] || {}, L), E.numberFormats = w.value, ss(E, v, L);
  }
  us++, t && dt && (bt(t.locale, (v) => {
    a && (l.value = v, E.locale = v, Jt(E, l.value, i.value));
  }), bt(t.fallbackLocale, (v) => {
    a && (i.value = v, E.fallbackLocale = v, Jt(E, l.value, i.value));
  }));
  const ee = {
    id: us,
    locale: V,
    fallbackLocale: q,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(v) {
      a = v, v && t && (l.value = t.locale.value, i.value = t.fallbackLocale.value, Jt(E, l.value, i.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: U,
    get modifiers() {
      return N;
    },
    get pluralRules() {
      return O || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return p;
    },
    set missingWarn(v) {
      p = v, E.missingWarn = p;
    },
    get fallbackWarn() {
      return x;
    },
    set fallbackWarn(v) {
      x = v, E.fallbackWarn = x;
    },
    get fallbackRoot() {
      return A;
    },
    set fallbackRoot(v) {
      A = v;
    },
    get fallbackFormat() {
      return y;
    },
    set fallbackFormat(v) {
      y = v, E.fallbackFormat = y;
    },
    get warnHtmlMessage() {
      return T;
    },
    set warnHtmlMessage(v) {
      T = v, E.warnHtmlMessage = v;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(v) {
      _ = v, E.escapeParameter = v;
    },
    t: Q,
    getLocaleMessage: yt,
    setLocaleMessage: zt,
    mergeLocaleMessage: Un,
    getPostTranslationHandler: I,
    setPostTranslationHandler: D,
    getMissingHandler: F,
    setMissingHandler: P,
    [el]: Be
  };
  return ee.datetimeFormats = ie, ee.numberFormats = S, ee.rt = le, ee.te = rt, ee.tm = Xt, ee.d = de, ee.n = be, ee.getDateTimeFormat = c, ee.setDateTimeFormat = u, ee.mergeDateTimeFormat = C, ee.getNumberFormat = $, ee.setNumberFormat = ce, ee.mergeNumberFormat = me, ee[Zs] = n, ee[to] = ze, ee[no] = ve, ee[oo] = Ge, process.env.NODE_ENV !== "production" && (ee[en] = (v) => {
    E.__v_emitter = v;
  }, ee[tn] = () => {
    E.__v_emitter = void 0;
  }), ee;
}
function _n(e, t) {
}
const vo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function rl({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, s) => [
    ...o,
    // prettier-ignore
    ...s.type === Ce ? s.children : [s]
  ], []) : t.reduce((n, o) => {
    const s = e[o];
    return s && (n[o] = s()), n;
  }, ae());
}
function tr() {
  return Ce;
}
_e({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => ke(e) || !isNaN(e)
  }
}, vo);
function al(e) {
  return ge(e) && !M(e[0]);
}
function nr(e, t, n, o) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = () => {
      const d = { part: !0 };
      let h = ae();
      e.locale && (d.locale = e.locale), M(e.format) ? d.key = e.format : Z(e.format) && (M(e.format.key) && (d.key = e.format.key), h = Object.keys(e.format).reduce((x, A) => n.includes(A) ? _e(ae(), x, { [A]: e.format[A] }) : x, ae()));
      const w = o(e.value, d, h);
      let p = [d.key];
      return ge(w) ? p = w.map((x, A) => {
        const y = s[x.type], k = y ? y({ [x.type]: x.value, index: A, parts: w }) : [x.value];
        return al(k) && (k[0].key = `${x.type}-${A}`), k;
      }) : M(w) && (p = [w]), p;
    }, l = _e(ae(), r), i = M(e.tag) || Z(e.tag) ? e.tag : tr();
    return Z(i) ? gn(i, l, { default: a }) : gn(i, l, a());
  };
}
_e({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vo);
const il = /* @__PURE__ */ mt("global-vue-i18n");
function jt(e = {}) {
  const t = bo();
  if (t == null)
    throw Rt(ye.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Rt(ye.NOT_INSTALLED);
  const n = ll(t), o = ul(n), s = er(t), r = cl(e, s);
  if (r === "global")
    return nl(o, e, s), o;
  if (r === "parent") {
    let i = ms(n, t, e.__useComponent);
    return i == null && (process.env.NODE_ENV !== "production" && nt(vn(tt.NOT_FOUND_PARENT_SCOPE)), i = o), i;
  }
  if (r === "isolated") {
    if (n.mode !== "composition")
      throw Rt(ye.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const i = n, d = _e({}, e), h = ms(n, t);
    d.__root = h || o;
    const w = fs(d);
    i.__composerExtend && (w[Mt] = i.__composerExtend(w));
    let p = null;
    if (process.env.NODE_ENV !== "production") {
      p = Os();
      const A = w;
      A[en] && A[en](p), p.on("*", _n);
    }
    return ea() && ta(() => {
      if (process.env.NODE_ENV !== "production") {
        p && p.off("*", _n);
        const y = w;
        y[tn] && y[tn]();
      }
      const A = w[Mt];
      A && (A(), delete w[Mt]);
    }), w;
  }
  const a = n;
  let l = a.__getInstance(t);
  if (l == null) {
    const i = _e({}, e);
    "__i18n" in s && (i.__i18n = s.__i18n), o && (i.__root = o), l = fs(i), a.__composerExtend && (l[Mt] = a.__composerExtend(l)), fl(a, t, l), a.__setInstance(t, l);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && nt(vn(tt.DUPLICATE_USE_I18N_CALLING));
  return l;
}
function ll(e) {
  const t = na(e.isCE ? il : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Rt(e.isCE ? ye.NOT_INSTALLED_WITH_PROVIDE : ye.UNEXPECTED_ERROR);
  return t;
}
function cl(e, t) {
  return In(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function ul(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ms(e, t, n = !1) {
  let o = null;
  const s = t.root;
  let r = dl(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const l = a.__getInstance(r);
      l != null && (o = l.__composer, n && o && !o[Zs] && (o = null));
    }
    if (o != null || s === r)
      break;
    r = r.parent;
  }
  return o;
}
function dl(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function fl(e, t, n) {
  let o = null;
  An(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Os();
      const s = n;
      s[en] && s[en](o), o.on("*", _n);
    }
  }, t), oa(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", _n), s[tn] && s[tn](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[Mt];
    r && (r(), delete s[Mt]);
  }, t);
}
_e({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, vo);
Zi();
Ii(ui);
Si(Li);
Di(Jn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Nt();
  e.__INTLIFY__ = !0, di(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function ml(e) {
  const t = J([]), n = J(!1), o = J(null), s = async () => {
    n.value = !0;
    try {
      t.value = await e.getConfigs();
    } catch (a) {
      o.value = a.message || "獲取配置失敗";
    } finally {
      n.value = !1;
    }
  };
  return { configs: t, isLoading: n, error: o, fetchConfigs: s, saveConfig: async (a) => {
    n.value = !0;
    try {
      await e.upsertConfig(a), await s();
    } catch (l) {
      throw o.value = l.message || "儲存配置失敗", l;
    } finally {
      n.value = !1;
    }
  } };
}
function pl(e) {
  const t = J([]), n = J(!1), o = J(!1), s = J(null);
  return {
    configs: t,
    loading: n,
    isSaving: o,
    error: s,
    loadConfigs: async () => {
      n.value = !0, s.value = null;
      try {
        const l = await e.fetchConfigs();
        t.value = l || [];
      } catch (l) {
        s.value = "無法載入時段配置", console.error("[TimeConfig] Load Failed:", l);
      } finally {
        n.value = !1;
      }
    },
    updateConfigs: async (l) => {
      o.value = !0, s.value = null;
      try {
        return await e.saveConfigs(l), t.value = [...l], !0;
      } catch (i) {
        return s.value = "儲存時段配置失敗", console.error("[TimeConfig] Save Failed:", i), !1;
      } finally {
        o.value = !1;
      }
    }
  };
}
function hl(e) {
  const t = J({ 0: [], 1: [], 2: [] }), n = J(!1), o = J(!1);
  return { holidayData: t, loading: n, isSaving: o, loadHolidays: async () => {
    n.value = !0;
    try {
      t.value = await e.getHolidays();
    } catch (a) {
      console.error("Fetch failed", a);
    } finally {
      n.value = !1;
    }
  }, submitHolidays: async (a) => {
    o.value = !0;
    try {
      await e.saveHolidays(a), t.value = a;
    } finally {
      o.value = !1;
    }
  } };
}
const gl = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, wl = {
  key: 0,
  class: "py-10 text-center text-slate-700"
}, bl = {
  key: 1,
  class: "space-y-3"
}, vl = ["onUpdate:modelValue"], _l = ["onUpdate:modelValue"], yl = { class: "flex items-end gap-2" }, El = { class: "flex-1" }, kl = ["onUpdate:modelValue"], xl = ["onClick"], Cl = { class: "pt-4 border-t border-slate-100 flex justify-end" }, Tl = ["disabled"], Ll = /* @__PURE__ */ ft({
  __name: "TimeConfigManager",
  props: {
    configs: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J([]);
    bt(() => n.configs, (i) => {
      s.value = JSON.parse(JSON.stringify(i));
    }, { immediate: !0 });
    const r = () => {
      s.value.push({ Start: "09:00", End: "12:00", Interval: 30 });
    }, a = (i) => {
      s.value.splice(i, 1);
    }, l = () => {
      o("save", s.value);
    };
    return (i, d) => (H(), Y("div", gl, [
      g("div", { class: "flex items-center justify-between" }, [
        d[0] || (d[0] = g("h3", { class: "text-lg font-bold text-slate-700" }, "營業時段配置", -1)),
        g("button", {
          onClick: r,
          class: "px-4 py-2 bg-indigo-100 text-indigo-700 rounded-xl text-sm font-bold hover:bg-indigo-100 transition-colors"
        }, " + 新增時段區間 ")
      ]),
      e.loading ? (H(), Y("div", wl, "讀取中...")) : (H(), Y("div", bl, [
        (H(!0), Y(Ce, null, Ke(s.value, (h, w) => (H(), Y("div", {
          key: w,
          class: "group relative grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-100 rounded-xl border border-transparent hover:border-indigo-100 transition-all"
        }, [
          g("div", null, [
            d[1] || (d[1] = g("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "開始時間", -1)),
            qe(g("input", {
              type: "time",
              "onUpdate:modelValue": (p) => h.Start = p,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, vl), [
              [pt, h.Start]
            ])
          ]),
          g("div", null, [
            d[2] || (d[2] = g("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "結束時間", -1)),
            qe(g("input", {
              type: "time",
              "onUpdate:modelValue": (p) => h.End = p,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, _l), [
              [pt, h.End]
            ])
          ]),
          g("div", yl, [
            g("div", El, [
              d[4] || (d[4] = g("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "間隔 (分鐘)", -1)),
              qe(g("select", {
                "onUpdate:modelValue": (p) => h.Interval = p,
                class: "w-full rounded-lg border-slate-100"
              }, [...d[3] || (d[3] = [
                g("option", { value: 15 }, "15 分鐘", -1),
                g("option", { value: 30 }, "30 分鐘", -1),
                g("option", { value: 60 }, "60 分鐘", -1)
              ])], 8, kl), [
                [
                  Ts,
                  h.Interval,
                  void 0,
                  { number: !0 }
                ]
              ])
            ]),
            g("button", {
              onClick: (p) => a(w),
              class: "p-2 text-red-700 hover:text-red-700 transition-colors"
            }, [...d[5] || (d[5] = [
              g("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                g("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)
            ])], 8, xl)
          ])
        ]))), 128)),
        g("div", Cl, [
          g("button", {
            onClick: l,
            disabled: e.isSaving,
            class: "px-8 py-2.5 bg-indigo-700 text-white rounded-xl font-bold hover:bg-indigo-700 disabled:opacity-100 shadow-lg shadow-indigo-100"
          }, z(e.isSaving ? "儲存中..." : "確認儲存"), 9, Tl)
        ])
      ]))
    ]));
  }
}), Nl = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, Al = { class: "flex justify-between items-center mb-8" }, Ol = { class: "flex gap-3" }, Il = ["disabled"], Sl = {
  key: 0,
  class: "py-20 text-center bg-slate-100 rounded-3xl border-2 border-dashed border-slate-200"
}, Dl = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}, Pl = ["onClick"], $l = { class: "flex items-center gap-4" }, Ml = { class: "w-12 h-12 bg-slate-100 text-slate-700 rounded-xl flex items-center justify-center text-lg font-black group-hover:bg-blue-700 group-hover:text-white transition-colors" }, Rl = { class: "font-bold text-slate-700" }, Fl = { class: "text-xs text-slate-700 font-bold" }, Ul = {
  key: 2,
  class: "fixed inset-0 bg-slate-700 backdrop-blur-sm flex items-center justify-center p-4 z-100"
}, Bl = { class: "bg-white rounded-[2rem] p-8 max-w-md w-full shadow-2xl" }, Vl = { class: "text-2xl font-black text-slate-700 mb-6" }, Hl = { class: "space-y-4" }, Yl = { class: "grid grid-cols-2 gap-4" }, jl = { class: "bg-blue-100 p-5 rounded-2xl space-y-3" }, Wl = { class: "grid grid-cols-2 gap-3" }, Gl = { class: "flex gap-4 mt-8" }, Kl = /* @__PURE__ */ ft({
  __name: "TableLayoutManager",
  props: {
    configs: {},
    loading: { type: Boolean }
  },
  emits: ["save", "refresh"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J(!1), r = Ls({}), a = (i) => {
      i ? Object.assign(r, JSON.parse(JSON.stringify(i))) : Object.assign(r, {
        id: void 0,
        table_number: n.configs.length > 0 ? Math.max(...n.configs.map((d) => d.table_number)) + 1 : 1,
        zone_id: 1,
        min_people: 2,
        max_people: 4
      }), s.value = !0;
    }, l = () => {
      o("save", { ...r }), s.value = !1;
    };
    return (i, d) => (H(), Y("div", Nl, [
      g("header", Al, [
        d[7] || (d[7] = g("div", null, [
          g("h2", { class: "text-2xl font-black text-slate-700" }, "桌位佈局管理"),
          g("p", { class: "text-sm text-slate-700" }, "管理區域、桌號與人數上限")
        ], -1)),
        g("div", Ol, [
          g("button", {
            onClick: d[0] || (d[0] = (h) => i.$emit("refresh")),
            disabled: e.loading,
            class: "p-2 text-slate-700 hover:text-blue-700 transition-colors"
          }, [
            g("span", {
              class: Pe({ "animate-spin inline-block": e.loading })
            }, "🔄", 2)
          ], 8, Il),
          g("button", {
            onClick: d[1] || (d[1] = (h) => a()),
            class: "bg-blue-700 text-white px-6 py-2 rounded-xl font-bold shadow-lg hover:bg-blue-700 transition"
          }, " + 新增桌位 ")
        ])
      ]),
      e.loading && e.configs.length === 0 ? (H(), Y("div", Sl, [...d[8] || (d[8] = [
        g("p", { class: "text-slate-700 font-bold" }, "讀取配置中...", -1)
      ])])) : (H(), Y("div", Dl, [
        (H(!0), Y(Ce, null, Ke(e.configs, (h) => (H(), Y("div", {
          key: h.id,
          onClick: (w) => a(h),
          class: "bg-white p-5 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-200 hover:shadow-md transition cursor-pointer flex justify-between items-center group"
        }, [
          g("div", $l, [
            g("div", Ml, z(h.table_number), 1),
            g("div", null, [
              g("div", Rl, "桌號 #" + z(h.table_number), 1),
              g("div", Fl, "區域 " + z(h.zone_id) + " • " + z(h.min_people) + "-" + z(h.max_people) + " 人", 1)
            ])
          ]),
          d[9] || (d[9] = g("span", { class: "text-blue-700 opacity-0 group-hover:opacity-100 transition-opacity text-sm font-bold" }, "編輯", -1))
        ], 8, Pl))), 128))
      ])),
      s.value ? (H(), Y("div", Ul, [
        g("div", Bl, [
          g("h2", Vl, z(r.id ? "編輯桌位" : "新增桌位"), 1),
          g("div", Hl, [
            g("div", Yl, [
              g("div", null, [
                d[10] || (d[10] = g("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "桌號", -1)),
                qe(g("input", {
                  "onUpdate:modelValue": d[2] || (d[2] = (h) => r.table_number = h),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.table_number,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ]),
              g("div", null, [
                d[11] || (d[11] = g("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "區域", -1)),
                qe(g("input", {
                  "onUpdate:modelValue": d[3] || (d[3] = (h) => r.zone_id = h),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.zone_id,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ]),
            g("div", jl, [
              d[12] || (d[12] = g("p", { class: "text-xs font-black text-blue-700 uppercase" }, "人數設定", -1)),
              g("div", Wl, [
                qe(g("input", {
                  "onUpdate:modelValue": d[4] || (d[4] = (h) => r.min_people = h),
                  type: "number",
                  placeholder: "最小",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.min_people,
                    void 0,
                    { number: !0 }
                  ]
                ]),
                qe(g("input", {
                  "onUpdate:modelValue": d[5] || (d[5] = (h) => r.max_people = h),
                  type: "number",
                  placeholder: "最大",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.max_people,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ])
          ]),
          g("div", Gl, [
            g("button", {
              onClick: d[6] || (d[6] = (h) => s.value = !1),
              class: "flex-1 py-4 text-slate-700 font-bold"
            }, "取消"),
            g("button", {
              onClick: l,
              class: "flex-[2] py-4 bg-blue-700 text-white rounded-2xl font-black text-lg shadow-lg"
            }, "確認儲存")
          ])
        ])
      ])) : $e("", !0)
    ]));
  }
}), ql = { class: "space-y-10" }, Xl = { class: "flex items-center justify-between border-b-2 border-slate-700 pb-4" }, zl = ["disabled"], Jl = {
  key: 0,
  class: "py-10 text-center font-black text-slate-700"
}, Zl = {
  key: 1,
  class: "space-y-12"
}, Ql = { class: "grid grid-cols-7 gap-1" }, ec = ["onClick"], tc = /* @__PURE__ */ ft({
  __name: "HolidayAdminPage",
  props: {
    holidayData: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J({ 0: [], 1: [], 2: [] }), r = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"], a = J(""), l = J("");
    bt(() => n.holidayData, (w) => {
      s.value = JSON.parse(JSON.stringify(w)), a.value = s.value[2].join(", "), l.value = s.value[1].map((p) => p.toString().padStart(4, "0")).join(", ");
    }, { immediate: !0, deep: !0 });
    const i = (w) => {
      const p = s.value[0].indexOf(w);
      p > -1 ? s.value[0].splice(p, 1) : s.value[0].push(w);
    }, d = () => {
      const w = a.value.split(",").map((A) => Number.parseInt(A.trim())).filter((A) => !Number.isNaN(A) && A >= 1 && A <= 31), p = l.value.split(",").map((A) => Number.parseInt(A.trim())).filter((A) => !Number.isNaN(A) && A >= 101 && A <= 1231), x = {
        0: s.value[0],
        1: Array.from(new Set(p)).sort((A, y) => A - y),
        2: Array.from(new Set(w)).sort((A, y) => A - y)
      };
      o("save", x);
    }, h = () => {
      const w = localStorage.getItem("merchantId");
      if (w) {
        const p = `/booking/${w}`;
        window.open(p, "_blank");
      } else
        alert("找不到商家資訊，無法前往預約頁面。");
    };
    return (w, p) => (H(), Y("div", ql, [
      g("div", { class: "flex items-center gap-2 mb-4" }, [
        g("button", {
          onClick: h,
          class: "bg-blue-700 text-white px-6 py-3 font-black text-sm hover:bg-sky-700 active:scale-95 transition-all shadow-lg hover:shadow-xl"
        }, " 線上預約頁面 ")
      ]),
      g("div", Xl, [
        p[2] || (p[2] = g("h3", { class: "text-xl font-black text-slate-700 uppercase tracking-tight" }, "Holiday Configuration", -1)),
        g("button", {
          onClick: d,
          disabled: e.isSaving || e.loading,
          class: "bg-slate-700 text-white px-6 py-2 font-black text-sm hover:bg-slate-700 active:scale-95 transition-all disabled:bg-slate-100"
        }, z(e.isSaving ? "SAVING..." : "CONFIRM SAVE"), 9, zl)
      ]),
      e.loading ? (H(), Y("div", Jl, "LOADING...")) : (H(), Y("div", Zl, [
        g("section", null, [
          p[3] || (p[3] = g("div", { class: "flex items-center gap-2 mb-4" }, [
            g("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 0"),
            g("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Weekly Recurring")
          ], -1)),
          g("div", Ql, [
            (H(), Y(Ce, null, Ke(r, (x, A) => g("button", {
              key: A,
              onClick: (y) => i(A),
              class: Pe([s.value[0].includes(A) ? "bg-slate-700 text-white" : "bg-slate-100 text-slate-700", "py-4 font-black text-xs transition-all border border-transparent hover:border-slate-700"])
            }, z(x), 11, ec)), 64))
          ])
        ]),
        g("section", null, [
          p[4] || (p[4] = g("div", { class: "flex items-center gap-2 mb-4" }, [
            g("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 2"),
            g("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Monthly Recurring (Days)")
          ], -1)),
          qe(g("input", {
            "onUpdate:modelValue": p[0] || (p[0] = (x) => a.value = x),
            placeholder: "Ex: 1, 15, 31",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [pt, a.value]
          ]),
          p[5] || (p[5] = g("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate days (1-31)", -1))
        ]),
        g("section", null, [
          p[6] || (p[6] = g("div", { class: "flex items-center gap-2 mb-4" }, [
            g("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 1"),
            g("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Specific Dates (MMDD)")
          ], -1)),
          qe(g("input", {
            "onUpdate:modelValue": p[1] || (p[1] = (x) => l.value = x),
            placeholder: "Ex: 0101, 1225",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [pt, l.value]
          ]),
          p[7] || (p[7] = g("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate dates (MonthDay format)", -1))
        ])
      ]))
    ]));
  }
}), nc = { class: "p-8 space-y-12 max-w-4xl" }, oc = { class: "bg-white p-8 border-2 border-slate-700" }, sc = { class: "p-8" }, rc = { class: "max-w-5xl mx-auto" }, ac = {
  key: 0,
  class: "fixed bottom-8 right-8 bg-red-600 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3"
}, ic = /* @__PURE__ */ ft({
  __name: "BookingConfigPage",
  props: {
    bookingApi: {},
    bookingTimeApi: {},
    holidayApi: {}
  },
  setup(e) {
    const { t } = jt(), n = e, {
      configs: o,
      // 重命名為時間配置
      loading: s,
      isSaving: r,
      loadConfigs: a,
      updateConfigs: l
    } = pl(n.bookingTimeApi), { configs: i, isLoading: d, error: h, fetchConfigs: w, saveConfig: p } = ml(n.bookingApi);
    J(!1), Ls({
      id: void 0,
      merchant_id: "",
      // 提交前會由後端或 Service 補上
      table_number: 1,
      zone_id: 1,
      min_people: 2,
      max_people: 4
    }), An(async () => {
      await w(), await a(), await A();
    });
    const {
      holidayData: x,
      loadHolidays: A
    } = hl(n.holidayApi), y = J(!1), k = J(!1), m = async (f) => {
      k.value = !0;
      try {
        await n.holidayApi.saveHolidays(f), x.value = f;
      } finally {
        k.value = !1;
      }
    };
    return (f, T) => (H(), Y(Ce, null, [
      g("div", nc, [
        g("div", oc, [
          Tt(tc, {
            holidayData: W(x),
            loading: y.value,
            isSaving: k.value,
            onSave: m
          }, null, 8, ["holidayData", "loading", "isSaving"])
        ])
      ]),
      g("div", sc, [
        Tt(Ll, {
          configs: W(o),
          loading: W(s),
          isSaving: W(r),
          onSave: W(l)
        }, null, 8, ["configs", "loading", "isSaving", "onSave"])
      ]),
      g("div", rc, [
        Tt(Kl, {
          configs: W(i),
          loading: W(d),
          onRefresh: W(w),
          onSave: W(p)
        }, null, 8, ["configs", "loading", "onRefresh", "onSave"]),
        Tt(lo, { name: "fade" }, {
          default: co(() => [
            W(h) ? (H(), Y("div", ac, [
              g("span", null, "⚠️ " + z(W(h)), 1),
              g("button", {
                onClick: T[0] || (T[0] = (_) => h.value = null),
                class: "bg-white/20 rounded-full w-6 h-6"
              }, "✕")
            ])) : $e("", !0)
          ]),
          _: 1
        })
      ])
    ], 64));
  }
}), _o = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, ym = /* @__PURE__ */ _o(ic, [["__scopeId", "data-v-b1467cb1"]]);
var yo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function or(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Wn = { exports: {} }, ps;
function sr() {
  return ps || (ps = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(yo, function() {
      var n = 1e3, o = 6e4, s = 36e5, r = "millisecond", a = "second", l = "minute", i = "hour", d = "day", h = "week", w = "month", p = "quarter", x = "year", A = "date", y = "Invalid Date", k = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, m = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, f = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(S) {
        var I = ["th", "st", "nd", "rd"], D = S % 100;
        return "[" + S + (I[(D - 20) % 10] || I[D] || I[0]) + "]";
      } }, T = function(S, I, D) {
        var F = String(S);
        return !F || F.length >= I ? S : "" + Array(I + 1 - F.length).join(D) + S;
      }, _ = { s: T, z: function(S) {
        var I = -S.utcOffset(), D = Math.abs(I), F = Math.floor(D / 60), P = D % 60;
        return (I <= 0 ? "+" : "-") + T(F, 2, "0") + ":" + T(P, 2, "0");
      }, m: function S(I, D) {
        if (I.date() < D.date()) return -S(D, I);
        var F = 12 * (D.year() - I.year()) + (D.month() - I.month()), P = I.clone().add(F, w), X = D - P < 0, B = I.clone().add(F + (X ? -1 : 1), w);
        return +(-(F + (D - P) / (X ? P - B : B - P)) || 0);
      }, a: function(S) {
        return S < 0 ? Math.ceil(S) || 0 : Math.floor(S);
      }, p: function(S) {
        return { M: w, y: x, w: h, d, D: A, h: i, m: l, s: a, ms: r, Q: p }[S] || String(S || "").toLowerCase().replace(/s$/, "");
      }, u: function(S) {
        return S === void 0;
      } }, N = "en", O = {};
      O[N] = f;
      var E = "$isDayjsObject", K = function(S) {
        return S instanceof U || !(!S || !S[E]);
      }, j = function S(I, D, F) {
        var P;
        if (!I) return N;
        if (typeof I == "string") {
          var X = I.toLowerCase();
          O[X] && (P = X), D && (O[X] = D, P = X);
          var B = I.split("-");
          if (!P && B.length > 1) return S(B[0]);
        } else {
          var Q = I.name;
          O[Q] = I, P = Q;
        }
        return !F && P && (N = P), P || !F && N;
      }, V = function(S, I) {
        if (K(S)) return S.clone();
        var D = typeof I == "object" ? I : {};
        return D.date = S, D.args = arguments, new U(D);
      }, q = _;
      q.l = j, q.i = K, q.w = function(S, I) {
        return V(S, { locale: I.$L, utc: I.$u, x: I.$x, $offset: I.$offset });
      };
      var U = function() {
        function S(D) {
          this.$L = j(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[E] = !0;
        }
        var I = S.prototype;
        return I.parse = function(D) {
          this.$d = function(F) {
            var P = F.date, X = F.utc;
            if (P === null) return /* @__PURE__ */ new Date(NaN);
            if (q.u(P)) return /* @__PURE__ */ new Date();
            if (P instanceof Date) return new Date(P);
            if (typeof P == "string" && !/Z$/i.test(P)) {
              var B = P.match(k);
              if (B) {
                var Q = B[2] - 1 || 0, le = (B[7] || "0").substring(0, 3);
                return X ? new Date(Date.UTC(B[1], Q, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le)) : new Date(B[1], Q, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le);
              }
            }
            return new Date(P);
          }(D), this.init();
        }, I.init = function() {
          var D = this.$d;
          this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
        }, I.$utils = function() {
          return q;
        }, I.isValid = function() {
          return this.$d.toString() !== y;
        }, I.isSame = function(D, F) {
          var P = V(D);
          return this.startOf(F) <= P && P <= this.endOf(F);
        }, I.isAfter = function(D, F) {
          return V(D) < this.startOf(F);
        }, I.isBefore = function(D, F) {
          return this.endOf(F) < V(D);
        }, I.$g = function(D, F, P) {
          return q.u(D) ? this[F] : this.set(P, D);
        }, I.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, I.valueOf = function() {
          return this.$d.getTime();
        }, I.startOf = function(D, F) {
          var P = this, X = !!q.u(F) || F, B = q.p(D), Q = function(Ge, ve) {
            var Be = q.w(P.$u ? Date.UTC(P.$y, ve, Ge) : new Date(P.$y, ve, Ge), P);
            return X ? Be : Be.endOf(d);
          }, le = function(Ge, ve) {
            return q.w(P.toDate()[Ge].apply(P.toDate("s"), (X ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ve)), P);
          }, de = this.$W, be = this.$M, Te = this.$D, st = "set" + (this.$u ? "UTC" : "");
          switch (B) {
            case x:
              return X ? Q(1, 0) : Q(31, 11);
            case w:
              return X ? Q(1, be) : Q(0, be + 1);
            case h:
              var We = this.$locale().weekStart || 0, ze = (de < We ? de + 7 : de) - We;
              return Q(X ? Te - ze : Te + (6 - ze), be);
            case d:
            case A:
              return le(st + "Hours", 0);
            case i:
              return le(st + "Minutes", 1);
            case l:
              return le(st + "Seconds", 2);
            case a:
              return le(st + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, I.endOf = function(D) {
          return this.startOf(D, !1);
        }, I.$set = function(D, F) {
          var P, X = q.p(D), B = "set" + (this.$u ? "UTC" : ""), Q = (P = {}, P[d] = B + "Date", P[A] = B + "Date", P[w] = B + "Month", P[x] = B + "FullYear", P[i] = B + "Hours", P[l] = B + "Minutes", P[a] = B + "Seconds", P[r] = B + "Milliseconds", P)[X], le = X === d ? this.$D + (F - this.$W) : F;
          if (X === w || X === x) {
            var de = this.clone().set(A, 1);
            de.$d[Q](le), de.init(), this.$d = de.set(A, Math.min(this.$D, de.daysInMonth())).$d;
          } else Q && this.$d[Q](le);
          return this.init(), this;
        }, I.set = function(D, F) {
          return this.clone().$set(D, F);
        }, I.get = function(D) {
          return this[q.p(D)]();
        }, I.add = function(D, F) {
          var P, X = this;
          D = Number(D);
          var B = q.p(F), Q = function(be) {
            var Te = V(X);
            return q.w(Te.date(Te.date() + Math.round(be * D)), X);
          };
          if (B === w) return this.set(w, this.$M + D);
          if (B === x) return this.set(x, this.$y + D);
          if (B === d) return Q(1);
          if (B === h) return Q(7);
          var le = (P = {}, P[l] = o, P[i] = s, P[a] = n, P)[B] || 1, de = this.$d.getTime() + D * le;
          return q.w(de, this);
        }, I.subtract = function(D, F) {
          return this.add(-1 * D, F);
        }, I.format = function(D) {
          var F = this, P = this.$locale();
          if (!this.isValid()) return P.invalidDate || y;
          var X = D || "YYYY-MM-DDTHH:mm:ssZ", B = q.z(this), Q = this.$H, le = this.$m, de = this.$M, be = P.weekdays, Te = P.months, st = P.meridiem, We = function(ve, Be, rt, Je) {
            return ve && (ve[Be] || ve(F, X)) || rt[Be].slice(0, Je);
          }, ze = function(ve) {
            return q.s(Q % 12 || 12, ve, "0");
          }, Ge = st || function(ve, Be, rt) {
            var Je = ve < 12 ? "AM" : "PM";
            return rt ? Je.toLowerCase() : Je;
          };
          return X.replace(m, function(ve, Be) {
            return Be || function(rt) {
              switch (rt) {
                case "YY":
                  return String(F.$y).slice(-2);
                case "YYYY":
                  return q.s(F.$y, 4, "0");
                case "M":
                  return de + 1;
                case "MM":
                  return q.s(de + 1, 2, "0");
                case "MMM":
                  return We(P.monthsShort, de, Te, 3);
                case "MMMM":
                  return We(Te, de);
                case "D":
                  return F.$D;
                case "DD":
                  return q.s(F.$D, 2, "0");
                case "d":
                  return String(F.$W);
                case "dd":
                  return We(P.weekdaysMin, F.$W, be, 2);
                case "ddd":
                  return We(P.weekdaysShort, F.$W, be, 3);
                case "dddd":
                  return be[F.$W];
                case "H":
                  return String(Q);
                case "HH":
                  return q.s(Q, 2, "0");
                case "h":
                  return ze(1);
                case "hh":
                  return ze(2);
                case "a":
                  return Ge(Q, le, !0);
                case "A":
                  return Ge(Q, le, !1);
                case "m":
                  return String(le);
                case "mm":
                  return q.s(le, 2, "0");
                case "s":
                  return String(F.$s);
                case "ss":
                  return q.s(F.$s, 2, "0");
                case "SSS":
                  return q.s(F.$ms, 3, "0");
                case "Z":
                  return B;
              }
              return null;
            }(ve) || B.replace(":", "");
          });
        }, I.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, I.diff = function(D, F, P) {
          var X, B = this, Q = q.p(F), le = V(D), de = (le.utcOffset() - this.utcOffset()) * o, be = this - le, Te = function() {
            return q.m(B, le);
          };
          switch (Q) {
            case x:
              X = Te() / 12;
              break;
            case w:
              X = Te();
              break;
            case p:
              X = Te() / 3;
              break;
            case h:
              X = (be - de) / 6048e5;
              break;
            case d:
              X = (be - de) / 864e5;
              break;
            case i:
              X = be / s;
              break;
            case l:
              X = be / o;
              break;
            case a:
              X = be / n;
              break;
            default:
              X = be;
          }
          return P ? X : q.a(X);
        }, I.daysInMonth = function() {
          return this.endOf(w).$D;
        }, I.$locale = function() {
          return O[this.$L];
        }, I.locale = function(D, F) {
          if (!D) return this.$L;
          var P = this.clone(), X = j(D, F, !0);
          return X && (P.$L = X), P;
        }, I.clone = function() {
          return q.w(this.$d, this);
        }, I.toDate = function() {
          return new Date(this.valueOf());
        }, I.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, I.toISOString = function() {
          return this.$d.toISOString();
        }, I.toString = function() {
          return this.$d.toUTCString();
        }, S;
      }(), ie = U.prototype;
      return V.prototype = ie, [["$ms", r], ["$s", a], ["$m", l], ["$H", i], ["$W", d], ["$M", w], ["$y", x], ["$D", A]].forEach(function(S) {
        ie[S[1]] = function(I) {
          return this.$g(I, S[0], S[1]);
        };
      }), V.extend = function(S, I) {
        return S.$i || (S(I, U, V), S.$i = !0), V;
      }, V.locale = j, V.isDayjs = K, V.unix = function(S) {
        return V(1e3 * S);
      }, V.en = O[N], V.Ls = O, V.p = {}, V;
    });
  }(Wn)), Wn.exports;
}
var lc = sr();
const it = /* @__PURE__ */ or(lc);
var cc = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o(sr());
  })(yo, function(n) {
    function o(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    var s = o(n), r = { name: "zh-tw", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(a, l) {
      return l === "W" ? a + "週" : a + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日dddd HH:mm", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s內", past: "%s前", s: "幾秒", m: "1 分鐘", mm: "%d 分鐘", h: "1 小時", hh: "%d 小時", d: "1 天", dd: "%d 天", M: "1 個月", MM: "%d 個月", y: "1 年", yy: "%d 年" }, meridiem: function(a, l) {
      var i = 100 * a + l;
      return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1100 ? "上午" : i < 1300 ? "中午" : i < 1800 ? "下午" : "晚上";
    } };
    return s.default.locale(r, null, !0), r;
  });
})(cc);
var rr = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(yo, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(r, a, l) {
      var i = a.prototype;
      l.utc = function(y) {
        var k = { date: y, utc: !0, args: arguments };
        return new a(k);
      }, i.utc = function(y) {
        var k = l(this.toDate(), { locale: this.$L, utc: !0 });
        return y ? k.add(this.utcOffset(), n) : k;
      }, i.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var d = i.parse;
      i.parse = function(y) {
        y.utc && (this.$u = !0), this.$utils().u(y.$offset) || (this.$offset = y.$offset), d.call(this, y);
      };
      var h = i.init;
      i.init = function() {
        if (this.$u) {
          var y = this.$d;
          this.$y = y.getUTCFullYear(), this.$M = y.getUTCMonth(), this.$D = y.getUTCDate(), this.$W = y.getUTCDay(), this.$H = y.getUTCHours(), this.$m = y.getUTCMinutes(), this.$s = y.getUTCSeconds(), this.$ms = y.getUTCMilliseconds();
        } else h.call(this);
      };
      var w = i.utcOffset;
      i.utcOffset = function(y, k) {
        var m = this.$utils().u;
        if (m(y)) return this.$u ? 0 : m(this.$offset) ? w.call(this) : this.$offset;
        if (typeof y == "string" && (y = function(N) {
          N === void 0 && (N = "");
          var O = N.match(o);
          if (!O) return null;
          var E = ("" + O[0]).match(s) || ["-", 0, 0], K = E[0], j = 60 * +E[1] + +E[2];
          return j === 0 ? 0 : K === "+" ? j : -j;
        }(y), y === null)) return this;
        var f = Math.abs(y) <= 16 ? 60 * y : y;
        if (f === 0) return this.utc(k);
        var T = this.clone();
        if (k) return T.$offset = f, T.$u = !1, T;
        var _ = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (T = this.local().add(f + _, n)).$offset = f, T.$x.$localOffset = _, T;
      };
      var p = i.format;
      i.format = function(y) {
        var k = y || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return p.call(this, k);
      }, i.valueOf = function() {
        var y = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * y;
      }, i.isUTC = function() {
        return !!this.$u;
      }, i.toISOString = function() {
        return this.toDate().toISOString();
      }, i.toString = function() {
        return this.toDate().toUTCString();
      };
      var x = i.toDate;
      i.toDate = function(y) {
        return y === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : x.call(this);
      };
      var A = i.diff;
      i.diff = function(y, k, m) {
        if (y && this.$u === y.$u) return A.call(this, y, k, m);
        var f = this.local(), T = l(y).local();
        return A.call(f, T, k, m);
      };
    };
  });
})(rr);
var uc = rr.exports;
const dc = /* @__PURE__ */ or(uc);
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function ar(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function fc(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function hs(e, t) {
  return e.get(ar(e, t));
}
function mc(e, t, n) {
  fc(e, t), t.set(e, n);
}
function pc(e, t, n) {
  return e.set(ar(e, t), n), n;
}
const hc = 100, R = {}, gc = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, wc = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    gc(), t();
  }, hc), window.scrollTo(n, o);
}), ir = "swal2-", bc = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], b = bc.reduce(
  (e, t) => (e[t] = ir + t, e),
  /** @type {SwalClasses} */
  {}
), vc = ["success", "warning", "info", "question", "error"], yn = vc.reduce(
  (e, t) => (e[t] = ir + t, e),
  /** @type {SwalIcons} */
  {}
), lr = "SweetAlert2:", Eo = (e) => e.charAt(0).toUpperCase() + e.slice(1), Ie = (e) => {
  console.warn(`${lr} ${typeof e == "object" ? e.join(" ") : e}`);
}, St = (e) => {
  console.error(`${lr} ${e}`);
}, gs = [], _c = (e) => {
  gs.includes(e) || (gs.push(e), Ie(e));
}, cr = (e, t = null) => {
  _c(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, Pn = (e) => typeof e == "function" ? e() : e, ko = (e) => e && typeof e.toPromise == "function", sn = (e) => ko(e) ? e.toPromise() : Promise.resolve(e), xo = (e) => e && Promise.resolve(e) === e, yc = () => navigator.userAgent.includes("Firefox"), Se = () => document.body.querySelector(`.${b.container}`), rn = (e) => {
  const t = Se();
  return t ? t.querySelector(e) : null;
}, Fe = (e) => rn(`.${e}`), oe = () => Fe(b.popup), Wt = () => Fe(b.icon), Ec = () => Fe(b["icon-content"]), ur = () => Fe(b.title), Co = () => Fe(b["html-container"]), dr = () => Fe(b.image), To = () => Fe(b["progress-steps"]), $n = () => Fe(b["validation-message"]), ot = () => (
  /** @type {HTMLButtonElement} */
  rn(`.${b.actions} .${b.confirm}`)
), Gt = () => (
  /** @type {HTMLButtonElement} */
  rn(`.${b.actions} .${b.cancel}`)
), Dt = () => (
  /** @type {HTMLButtonElement} */
  rn(`.${b.actions} .${b.deny}`)
), kc = () => Fe(b["input-label"]), Kt = () => rn(`.${b.loader}`), an = () => Fe(b.actions), fr = () => Fe(b.footer), Mn = () => Fe(b["timer-progress-bar"]), Lo = () => Fe(b.close), xc = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, No = () => {
  const e = oe();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const l = parseInt(r.getAttribute("tabindex") || "0"), i = parseInt(a.getAttribute("tabindex") || "0");
    return l > i ? 1 : l < i ? -1 : 0;
  }), o = e.querySelectorAll(xc), s = Array.from(o).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(s))].filter((r) => De(r));
}, Ao = () => ut(document.body, b.shown) && !ut(document.body, b["toast-shown"]) && !ut(document.body, b["no-backdrop"]), Rn = () => {
  const e = oe();
  return e ? ut(e, b.toast) : !1;
}, Cc = () => {
  const e = oe();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ue = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), s = o.querySelector("head");
    s && Array.from(s.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = o.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, ut = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, Tc = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(b).includes(n) && !Object.values(yn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, Re = (e, t, n) => {
  if (Tc(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Ie(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    ne(e, o);
  }
}, Fn = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${b.popup} > .${b[t]}`);
    case "checkbox":
      return e.querySelector(`.${b.popup} > .${b.checkbox} input`);
    case "radio":
      return e.querySelector(`.${b.popup} > .${b.radio} input:checked`) || e.querySelector(`.${b.popup} > .${b.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${b.popup} > .${b.range} input`);
    default:
      return e.querySelector(`.${b.popup} > .${b.input}`);
  }
}, mr = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, pr = (e, t, n) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((r) => {
    o.forEach((a) => {
      n ? r.classList.add(a) : r.classList.remove(a);
    });
  });
}, ne = (e, t) => {
  pr(e, t, !0);
}, je = (e, t) => {
  pr(e, t, !1);
}, ht = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && ut(n, t))
), At = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, xe = (e, t = "flex") => {
  e && (e.style.display = t);
}, Oe = (e) => {
  e && (e.style.display = "none");
}, Oo = (e, t = "block") => {
  e && new MutationObserver(() => {
    ln(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, ws = (e, t, n, o) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(n, o);
}, ln = (e, t, n = "flex") => {
  t ? xe(e, n) : Oe(e);
}, De = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Lc = () => !De(ot()) && !De(Dt()) && !De(Gt()), so = (e) => e.scrollHeight > e.clientHeight, Nc = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (so(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, hr = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, Io = (e, t = !1) => {
  const n = Mn();
  n && De(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Ac = () => {
  const e = Mn();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Oc = () => typeof window > "u" || typeof document > "u", Ic = `
 <div aria-labelledby="${b.title}" aria-describedby="${b["html-container"]}" class="${b.popup}" tabindex="-1">
   <button type="button" class="${b.close}"></button>
   <ul class="${b["progress-steps"]}"></ul>
   <div class="${b.icon}"></div>
   <img class="${b.image}" />
   <h2 class="${b.title}" id="${b.title}"></h2>
   <div class="${b["html-container"]}" id="${b["html-container"]}"></div>
   <input class="${b.input}" id="${b.input}" />
   <input type="file" class="${b.file}" />
   <div class="${b.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${b.select}" id="${b.select}"></select>
   <div class="${b.radio}"></div>
   <label class="${b.checkbox}">
     <input type="checkbox" id="${b.checkbox}" />
     <span class="${b.label}"></span>
   </label>
   <textarea class="${b.textarea}" id="${b.textarea}"></textarea>
   <div class="${b["validation-message"]}" id="${b["validation-message"]}"></div>
   <div class="${b.actions}">
     <div class="${b.loader}"></div>
     <button type="button" class="${b.confirm}"></button>
     <button type="button" class="${b.deny}"></button>
     <button type="button" class="${b.cancel}"></button>
   </div>
   <div class="${b.footer}"></div>
   <div class="${b["timer-progress-bar-container"]}">
     <div class="${b["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Sc = () => {
  const e = Se();
  return e ? (e.remove(), je([document.documentElement, document.body], [
    b["no-backdrop"],
    b["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    b["has-column"]
  ]), !0) : !1;
}, Ct = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, Dc = () => {
  const e = oe();
  if (!e)
    return;
  const t = ht(e, b.input), n = ht(e, b.file), o = e.querySelector(`.${b.range} input`), s = e.querySelector(`.${b.range} output`), r = ht(e, b.select), a = e.querySelector(`.${b.checkbox} input`), l = ht(e, b.textarea);
  t && (t.oninput = Ct), n && (n.onchange = Ct), r && (r.onchange = Ct), a && (a.onchange = Ct), l && (l.oninput = Ct), o && s && (o.oninput = () => {
    Ct(), s.value = o.value;
  }, o.onchange = () => {
    Ct(), s.value = o.value;
  });
}, Pc = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, $c = (e) => {
  const t = oe();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Mc = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (ne(Se(), b.rtl), R.isRTL = !0);
}, Rc = (e) => {
  const t = Sc();
  if (Oc()) {
    St("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = b.container, t && ne(n, b["no-transition"]), Ue(n, Ic), n.dataset.swal2Theme = e.theme;
  const o = Pc(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), $c(e), Mc(o), Dc();
}, So = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Fc(e, t) : e && Ue(t, e);
}, Fc = (e, t) => {
  "jquery" in e ? Uc(t, e) : Ue(t, e.toString());
}, Uc = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Bc = (e, t) => {
  const n = an(), o = Kt();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Oe(n) : xe(n), Re(n, t, "actions"), Vc(n, o, t), Ue(o, t.loaderHtml || ""), Re(o, t, "loader"));
};
function Vc(e, t, n) {
  const o = ot(), s = Dt(), r = Gt();
  !o || !s || !r || (Gn(o, "confirm", n), Gn(s, "deny", n), Gn(r, "cancel", n), Hc(o, s, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, o), e.insertBefore(s, o)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(o, t))));
}
function Hc(e, t, n, o) {
  if (!o.buttonsStyling) {
    je([e, t, n], b.styled);
    return;
  }
  ne([e, t, n], b.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [n, "cancel", o.cancelButtonColor]].forEach(([r, a, l]) => {
    l && r.style.setProperty(`--swal2-${a}-button-background-color`, l), Yc(r);
  });
}
function Yc(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Gn(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Eo(t)
  );
  ln(e, n[`show${o}Button`], "inline-block"), Ue(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = b[t], Re(e, n, `${t}Button`);
}
const jc = (e, t) => {
  const n = Lo();
  n && (Ue(n, t.closeButtonHtml || ""), Re(n, t, "closeButton"), ln(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Wc = (e, t) => {
  const n = Se();
  n && (Gc(n, t.backdrop), Kc(n, t.position), qc(n, t.grow), Re(n, t, "container"));
};
function Gc(e, t) {
  typeof t == "string" ? e.style.background = t : t || ne([document.documentElement, document.body], b["no-backdrop"]);
}
function Kc(e, t) {
  t && (t in b ? ne(e, b[t]) : (Ie('The "position" parameter is not valid, defaulting to "center"'), ne(e, b.center)));
}
function qc(e, t) {
  t && ne(e, b[`grow-${t}`]);
}
var re = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const Xc = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], zc = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = re.innerParams.get(e), s = !o || t.input !== o.input;
  Xc.forEach((r) => {
    const a = ht(n, b[r]);
    a && (Qc(r, t.inputAttributes), a.className = b[r], s && Oe(a));
  }), t.input && (s && Jc(t), eu(t));
}, Jc = (e) => {
  if (!e.input)
    return;
  if (!pe[e.input]) {
    St(`Unexpected type of input! Expected ${Object.keys(pe).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = gr(e.input);
  if (!t)
    return;
  const n = pe[e.input](t, e);
  xe(t), e.inputAutoFocus && setTimeout(() => {
    mr(n);
  });
}, Zc = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, Qc = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = Fn(n, e);
  if (o) {
    Zc(o);
    for (const s in t)
      o.setAttribute(s, t[s]);
  }
}, eu = (e) => {
  if (!e.input)
    return;
  const t = gr(e.input);
  t && Re(t, e, "input");
}, Do = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, cn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), s = b["input-label"];
    o.setAttribute("for", e.id), o.className = s, typeof n.customClass == "object" && ne(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, gr = (e) => {
  const t = oe();
  if (t)
    return ht(t, b[
      /** @type {SwalClass} */
      e
    ] || b.input);
}, En = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : xo(t) || Ie(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, pe = {};
pe.text = pe.email = pe.password = pe.number = pe.tel = pe.url = pe.search = pe.date = pe["datetime-local"] = pe.time = pe.week = pe.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return En(n, t.inputValue), cn(n, n, t), Do(n, t), n.type = /** @type {string} */
  t.input, n;
};
pe.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return cn(n, n, t), Do(n, t), n;
};
pe.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), s = n.querySelector("output");
  return o && (En(o, t.inputValue), o.type = /** @type {string} */
  t.input, cn(
    o,
    /** @type {Input} */
    e,
    t
  )), s && En(s, t.inputValue), /** @type {Input} */
  e;
};
pe.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ue(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return cn(n, n, t), n;
};
pe.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
pe.checkbox = (e, t) => {
  const n = oe();
  if (!n)
    throw new Error("Popup not found");
  const o = Fn(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = /** @type {HTMLElement} */ e.querySelector("span");
  if (r) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && Ue(r, a);
  }
  return o;
};
pe.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  En(n, t.inputValue), Do(n, t), cn(n, n, t);
  const o = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = oe();
      if (!s)
        return;
      const r = parseInt(window.getComputedStyle(s).width), a = () => {
        if (!document.body.contains(n))
          return;
        const l = n.offsetWidth + o(n), i = oe();
        i && (l > r ? i.style.width = `${l}px` : At(i, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const tu = (e, t) => {
  const n = Co();
  n && (Oo(n), Re(n, t, "htmlContainer"), t.html ? (So(t.html, n), xe(n, "block")) : t.text ? (n.textContent = t.text, xe(n, "block")) : Oe(n), zc(e, t));
}, nu = (e, t) => {
  const n = fr();
  n && (Oo(n), ln(n, !!t.footer, "block"), t.footer && So(t.footer, n), Re(n, t, "footer"));
}, ou = (e, t) => {
  const n = re.innerParams.get(e), o = Wt();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    vs(o, t), bs(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Oe(o);
    return;
  }
  if (t.icon && Object.keys(yn).indexOf(t.icon) === -1) {
    St(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Oe(o);
    return;
  }
  xe(o), vs(o, t), bs(o, t), ne(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", wr);
}, bs = (e, t) => {
  for (const [n, o] of Object.entries(yn))
    t.icon !== n && je(e, o);
  ne(e, t.icon && yn[t.icon]), au(e, t), wr(), Re(e, t, "icon");
}, wr = () => {
  const e = oe();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, su = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, ru = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, vs = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = _s(t.iconHtml) : t.icon === "success" ? (o = su(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = ru : t.icon && (o = _s({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ue(e, o);
}, au = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      ws(e, n, "background-color", t.iconColor);
    ws(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, _s = (e) => `<div class="${b["icon-content"]}">${e}</div>`, iu = (e, t) => {
  const n = dr();
  if (n) {
    if (!t.imageUrl) {
      Oe(n);
      return;
    }
    xe(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), At(n, "width", t.imageWidth), At(n, "height", t.imageHeight), n.className = b.image, Re(n, t, "image");
  }
};
let Po = !1, br = 0, vr = 0, _r = 0, yr = 0;
const lu = (e) => {
  e.addEventListener("mousedown", kn), document.body.addEventListener("mousemove", xn), e.addEventListener("mouseup", Cn), e.addEventListener("touchstart", kn), document.body.addEventListener("touchmove", xn), e.addEventListener("touchend", Cn);
}, cu = (e) => {
  e.removeEventListener("mousedown", kn), document.body.removeEventListener("mousemove", xn), e.removeEventListener("mouseup", Cn), e.removeEventListener("touchstart", kn), document.body.removeEventListener("touchmove", xn), e.removeEventListener("touchend", Cn);
}, kn = (e) => {
  const t = oe();
  if (!t)
    return;
  const n = Wt();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Po = !0;
    const o = Er(e);
    br = o.clientX, vr = o.clientY, _r = parseInt(t.style.insetInlineStart) || 0, yr = parseInt(t.style.insetBlockStart) || 0, ne(t, "swal2-dragging");
  }
}, xn = (e) => {
  const t = oe();
  if (t && Po) {
    let {
      clientX: n,
      clientY: o
    } = Er(e);
    const s = n - br;
    t.style.insetInlineStart = `${_r + (R.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${yr + (o - vr)}px`;
  }
}, Cn = () => {
  const e = oe();
  Po = !1, je(e, "swal2-dragging");
}, Er = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, uu = (e, t) => {
  const n = Se(), o = oe();
  if (!(!n || !o)) {
    if (t.toast) {
      At(n, "width", t.width), o.style.width = "100%";
      const s = Kt();
      s && o.insertBefore(s, Wt());
    } else
      At(o, "width", t.width);
    At(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Oe($n()), du(o, t), t.draggable && !t.toast ? (ne(o, b.draggable), lu(o)) : (je(o, b.draggable), cu(o));
  }
}, du = (e, t) => {
  const n = t.showClass || {};
  e.className = `${b.popup} ${De(e) ? n.popup : ""}`, t.toast ? (ne([document.documentElement, document.body], b["toast-shown"]), ne(e, b.toast)) : ne(e, b.modal), Re(e, t, "popup"), typeof t.customClass == "string" && ne(e, t.customClass), t.icon && ne(e, b[`icon-${t.icon}`]);
}, fu = (e, t) => {
  const n = To();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: s
  } = t;
  if (!o || o.length === 0 || s === void 0) {
    Oe(n);
    return;
  }
  xe(n), n.textContent = "", s >= o.length && Ie("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((r, a) => {
    const l = mu(r);
    if (n.appendChild(l), a === s && ne(l, b["active-progress-step"]), a !== o.length - 1) {
      const i = pu(t);
      n.appendChild(i);
    }
  });
}, mu = (e) => {
  const t = document.createElement("li");
  return ne(t, b["progress-step"]), Ue(t, e), t;
}, pu = (e) => {
  const t = document.createElement("li");
  return ne(t, b["progress-step-line"]), e.progressStepsDistance && At(t, "width", e.progressStepsDistance), t;
}, hu = (e, t) => {
  const n = ur();
  n && (Oo(n), ln(n, !!(t.title || t.titleText), "block"), t.title && So(t.title, n), t.titleText && (n.innerText = t.titleText), Re(n, t, "title"));
}, kr = (e, t) => {
  var n;
  uu(e, t), Wc(e, t), fu(e, t), ou(e, t), iu(e, t), hu(e, t), jc(e, t), tu(e, t), Bc(e, t), nu(e, t);
  const o = oe();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, gu = () => De(oe()), xr = () => {
  var e;
  return (e = ot()) === null || e === void 0 ? void 0 : e.click();
}, wu = () => {
  var e;
  return (e = Dt()) === null || e === void 0 ? void 0 : e.click();
}, bu = () => {
  var e;
  return (e = Gt()) === null || e === void 0 ? void 0 : e.click();
}, qt = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Cr = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, vu = (e, t, n) => {
  if (Cr(e), !t.toast) {
    const o = (r) => yu(t, r, n);
    e.keydownHandler = o;
    const s = t.keydownListenerCapture ? window : oe();
    if (s) {
      e.keydownTarget = s, e.keydownListenerCapture = t.keydownListenerCapture;
      const r = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", r, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, ro = (e, t) => {
  var n;
  const o = No();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(yc() && o[e] instanceof HTMLIFrameElement)) : ((n = oe()) === null || n === void 0 || n.focus(), !0);
}, Tr = ["ArrowRight", "ArrowDown"], _u = ["ArrowLeft", "ArrowUp"], yu = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Eu(t, e) : t.key === "Tab" ? ku(t) : [...Tr, ..._u].includes(t.key) ? xu(t.key) : t.key === "Escape" && Cu(t, e, n)));
}, Eu = (e, t) => {
  if (!Pn(t.allowEnterKey))
    return;
  const n = oe();
  if (!n || !t.input)
    return;
  const o = Fn(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    xr(), e.preventDefault();
  }
}, ku = (e) => {
  const t = e.target, o = No().findIndex((r) => r === t);
  let s = !0;
  e.shiftKey ? s = ro(o, -1) : s = ro(o, 1), e.stopPropagation(), s && e.preventDefault();
}, xu = (e) => {
  const t = an(), n = ot(), o = Dt(), s = Gt();
  if (!t || !n || !o || !s)
    return;
  const r = [n, o, s];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = Tr.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let l = document.activeElement;
  if (l) {
    for (let i = 0; i < t.children.length; i++) {
      if (l = l[a], !l)
        return;
      if (l instanceof HTMLButtonElement && De(l))
        break;
    }
    l instanceof HTMLButtonElement && l.focus();
  }
}, Cu = (e, t, n) => {
  e.preventDefault(), Pn(t.allowEscapeKey) && n(qt.esc);
};
var Vt = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Tu = () => {
  const e = Se();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Lr = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, $o = typeof window < "u" && !!window.GestureEvent, Lu = $o && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Nu = () => {
  if ($o && !ut(document.body, b.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, ne(document.body, b.iosfix), Au();
  }
}, Au = () => {
  const e = Se();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Ou(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Ou = (e) => {
  const t = e.target, n = Se(), o = Co();
  return !n || !o || Iu(e) || Su(e) ? !1 : t === n || !so(n) && t instanceof HTMLElement && !Nc(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(so(o) && // #1944
  o.contains(t));
}, Iu = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), Su = (e) => e.touches && e.touches.length > 1, Du = () => {
  if (ut(document.body, b.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    je(document.body, b.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Pu = () => {
  const e = document.createElement("div");
  e.className = b["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let Ft = null;
const $u = (e) => {
  Ft === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (Ft = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${Ft + Pu()}px`);
}, Mu = () => {
  Ft !== null && (document.body.style.paddingRight = `${Ft}px`, Ft = null);
};
function Nr(e, t, n, o) {
  Rn() ? ys(e, o) : (wc(n).then(() => ys(e, o)), Cr(R)), $o ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Ao() && (Mu(), Du(), Lr()), Ru();
}
function Ru() {
  je([document.documentElement, document.body], [b.shown, b["height-auto"], b["no-backdrop"], b["toast-shown"]]);
}
function gt(e) {
  e = Uu(e);
  const t = Vt.swalPromiseResolve.get(this), n = Fu(this);
  this.isAwaitingPromise ? e.isDismissed || (un(this), t(e)) : n && t(e);
}
const Fu = (e) => {
  const t = oe();
  if (!t)
    return !1;
  const n = re.innerParams.get(e);
  if (!n || ut(t, n.hideClass.popup))
    return !1;
  je(t, n.showClass.popup), ne(t, n.hideClass.popup);
  const o = Se();
  return je(o, n.showClass.backdrop), ne(o, n.hideClass.backdrop), Bu(e, t, n), !0;
};
function Ar(e) {
  const t = Vt.swalPromiseReject.get(this);
  un(this), t && t(e);
}
const un = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, re.innerParams.get(e) || e._destroy());
}, Uu = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Bu = (e, t, n) => {
  var o;
  const s = Se(), r = hr(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), r && s ? Vu(e, t, s, !!n.returnFocus, n.didClose) : s && Nr(e, s, !!n.returnFocus, n.didClose);
}, Vu = (e, t, n, o, s) => {
  R.swalCloseEventFinishedCallback = Nr.bind(null, e, n, o, s);
  const r = function(a) {
    if (a.target === t) {
      var l;
      (l = R.swalCloseEventFinishedCallback) === null || l === void 0 || l.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, ys = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, Ht = (e) => {
  let t = oe();
  if (t || new on(), t = oe(), !t)
    return;
  const n = Kt();
  Rn() ? Oe(Wt()) : Hu(t, e), xe(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Hu = (e, t) => {
  const n = an(), o = Kt();
  !n || !o || (!t && De(ot()) && (t = ot()), xe(n), t && (Oe(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), ne([e, n], b.loading));
}, Yu = (e, t) => {
  t.input === "select" || t.input === "radio" ? qu(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (ko(t.inputValue) || xo(t.inputValue)) && (Ht(ot()), Xu(e, t));
}, ju = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Wu(n);
    case "radio":
      return Gu(n);
    case "file":
      return Ku(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Wu = (e) => e.checked ? 1 : 0, Gu = (e) => e.checked ? e.value : null, Ku = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, qu = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = (s) => {
    t.input === "select" ? zu(n, ao(s), t) : t.input === "radio" && Ju(n, ao(s), t);
  };
  ko(t.inputOptions) || xo(t.inputOptions) ? (Ht(ot()), sn(t.inputOptions).then((s) => {
    e.hideLoading(), o(s);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : St(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Xu = (e, t) => {
  const n = e.getInput();
  n && (Oe(n), sn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, xe(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    St(`Error in inputValue promise: ${o}`), n.value = "", xe(n), n.focus(), e.hideLoading();
  }));
};
function zu(e, t, n) {
  const o = ht(e, b.select);
  if (!o)
    return;
  const s = (r, a, l) => {
    const i = document.createElement("option");
    i.value = l, Ue(i, a), i.selected = Or(l, n.inputValue), r.appendChild(i);
  };
  t.forEach((r) => {
    const a = r[0], l = r[1];
    if (Array.isArray(l)) {
      const i = document.createElement("optgroup");
      i.label = a, i.disabled = !1, o.appendChild(i), l.forEach((d) => s(i, d[1], d[0]));
    } else
      s(o, l, a);
  }), o.focus();
}
function Ju(e, t, n) {
  const o = ht(e, b.radio);
  if (!o)
    return;
  t.forEach((r) => {
    const a = r[0], l = r[1], i = document.createElement("input"), d = document.createElement("label");
    i.type = "radio", i.name = b.radio, i.value = a, Or(a, n.inputValue) && (i.checked = !0);
    const h = document.createElement("span");
    Ue(h, l), h.className = b.label, d.appendChild(i), d.appendChild(h), o.appendChild(d);
  });
  const s = o.querySelectorAll("input");
  s.length && s[0].focus();
}
const ao = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, o]) => [n, typeof o == "object" ? ao(o) : o]), Or = (e, t) => !!t && t != null && t.toString() === e.toString(), Zu = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.input ? Ir(e, "confirm") : Ro(e, !0);
}, Qu = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Ir(e, "deny") : Mo(e, !1);
}, ed = (e, t) => {
  e.disableButtons(), t(qt.cancel);
}, Ir = (e, t) => {
  const n = re.innerParams.get(e);
  if (!n.input) {
    St(`The "input" parameter is needed to be set when using returnInputValueOn${Eo(t)}`);
    return;
  }
  const o = e.getInput(), s = ju(e, n);
  n.inputValidator ? td(e, s, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Mo(e, s) : Ro(e, s);
}, td = (e, t, n) => {
  const o = re.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => sn(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Mo(e, t) : Ro(e, t);
  });
}, Mo = (e, t) => {
  const n = re.innerParams.get(e);
  n.showLoaderOnDeny && Ht(Dt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => sn(n.preDeny(t, n.validationMessage))).then((s) => {
    s === !1 ? (e.hideLoading(), un(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof s > "u" ? t : s
      }
    );
  }).catch((s) => Sr(e, s))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Es = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Sr = (e, t) => {
  e.rejectPromise(t);
}, Ro = (e, t) => {
  const n = re.innerParams.get(e);
  n.showLoaderOnConfirm && Ht(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => sn(n.preConfirm(t, n.validationMessage))).then((s) => {
    De($n()) || s === !1 ? (e.hideLoading(), un(e)) : Es(e, typeof s > "u" ? t : s);
  }).catch((s) => Sr(e, s))) : Es(e, t);
};
function Tn() {
  const e = re.innerParams.get(this);
  if (!e)
    return;
  const t = re.domCache.get(this);
  Oe(t.loader), Rn() ? e.icon && xe(Wt()) : nd(t), je([t.popup, t.actions], b.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const nd = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? xe(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Lc() && Oe(e.actions);
};
function Dr() {
  const e = re.innerParams.get(this), t = re.domCache.get(this);
  return t ? Fn(t.popup, e.input) : null;
}
function Pr(e, t, n) {
  const o = re.domCache.get(e);
  t.forEach((s) => {
    o[s].disabled = n;
  });
}
function $r(e, t) {
  const n = oe();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${b.radio}"]`).forEach((s) => {
    s.disabled = t;
  }) : e.disabled = t);
}
function Mr() {
  Pr(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = re.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), re.focusedElement.delete(this);
}
function Rr() {
  re.focusedElement.set(this, document.activeElement), Pr(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Fr() {
  $r(this.getInput(), !1);
}
function Ur() {
  $r(this.getInput(), !0);
}
function Br(e) {
  const t = re.domCache.get(this), n = re.innerParams.get(this);
  Ue(t.validationMessage, e), t.validationMessage.className = b["validation-message"], n.customClass && n.customClass.validationMessage && ne(t.validationMessage, n.customClass.validationMessage), xe(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", b["validation-message"]), mr(o), ne(o, b.inputerror));
}
function Vr() {
  const e = re.domCache.get(this);
  e.validationMessage && Oe(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), je(t, b.inputerror));
}
const wt = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, od = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], sd = {
  allowEnterKey: void 0
}, rd = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Hr = (e) => Object.prototype.hasOwnProperty.call(wt, e), Yr = (e) => od.indexOf(e) !== -1, jr = (e) => sd[e], ad = (e) => {
  Hr(e) || Ie(`Unknown parameter "${e}"`);
}, id = (e) => {
  rd.includes(e) && Ie(`The parameter "${e}" is incompatible with toasts`);
}, ld = (e) => {
  const t = jr(e);
  t && cr(e, t);
}, Wr = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Ie('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Ie(`Invalid theme "${e.theme}"`);
  for (const t in e)
    ad(t), e.toast && id(t), ld(t);
};
function Gr(e) {
  const t = Se(), n = oe(), o = re.innerParams.get(this);
  if (!n || ut(n, o.hideClass.popup)) {
    Ie("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = cd(e), r = Object.assign({}, o, s);
  Wr(r), t && (t.dataset.swal2Theme = r.theme), kr(this, r), re.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const cd = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (Yr(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Ie(`Invalid parameter to update: ${n}`);
  }), t;
};
function Kr() {
  var e;
  const t = re.domCache.get(this), n = re.innerParams.get(this);
  if (!n) {
    qr(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), ud(this);
}
const ud = (e) => {
  qr(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, qr = (e) => {
  e.isAwaitingPromise ? (Kn(re, e), e.isAwaitingPromise = !0) : (Kn(Vt, e), Kn(re, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Kn = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var dd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Kr,
  close: gt,
  closeModal: gt,
  closePopup: gt,
  closeToast: gt,
  disableButtons: Rr,
  disableInput: Ur,
  disableLoading: Tn,
  enableButtons: Mr,
  enableInput: Fr,
  getInput: Dr,
  handleAwaitingPromise: un,
  hideLoading: Tn,
  rejectPromise: Ar,
  resetValidationMessage: Vr,
  showValidationMessage: Br,
  update: Gr
});
const fd = (e, t, n) => {
  e.toast ? md(e, t, n) : (hd(t), gd(t), wd(e, t, n));
}, md = (e, t, n) => {
  t.popup.onclick = () => {
    e && (pd(e) || e.timer || e.input) || n(qt.close);
  };
}, pd = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let Ln = !1;
const hd = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (Ln = !0);
    };
  };
}, gd = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (Ln = !0);
    };
  };
}, wd = (e, t, n) => {
  t.container.onclick = (o) => {
    if (Ln) {
      Ln = !1;
      return;
    }
    o.target === t.container && Pn(e.allowOutsideClick) && n(qt.backdrop);
  };
}, bd = (e) => typeof e == "object" && e !== null && "jquery" in e, ks = (e) => e instanceof Element || bd(e), vd = (e) => {
  const t = {};
  return typeof e[0] == "object" && !ks(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const s = e[o];
    typeof s == "string" || ks(s) ? t[n] = s : s !== void 0 && St(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof s}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function _d(...e) {
  return new this(...e);
}
function yd(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, s) {
      return super._main(o, Object.assign({}, e, s));
    }
  }
  return t;
}
const Ed = () => R.timeout && R.timeout.getTimerLeft(), Xr = () => {
  if (R.timeout)
    return Ac(), R.timeout.stop();
}, zr = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return Io(e), e;
  }
}, kd = () => {
  const e = R.timeout;
  return e && (e.running ? Xr() : zr());
}, xd = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return Io(t, !0), t;
  }
}, Cd = () => !!(R.timeout && R.timeout.isRunning());
let xs = !1;
const io = {};
function Td(e = "data-swal-template") {
  io[e] = this, xs || (document.body.addEventListener("click", Ld), xs = !0);
}
const Ld = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in io) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        io[n].fire({
          template: o
        });
        return;
      }
    }
};
class Nd {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...s) => {
      this.removeListener(t, o), n.apply(this, s);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), s = o.indexOf(n);
    s > -1 && o.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new Nd();
const Ad = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, Od = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, Id = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var Sd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: vd,
  bindClickHandler: Td,
  clickCancel: bu,
  clickConfirm: xr,
  clickDeny: wu,
  enableLoading: Ht,
  fire: _d,
  getActions: an,
  getCancelButton: Gt,
  getCloseButton: Lo,
  getConfirmButton: ot,
  getContainer: Se,
  getDenyButton: Dt,
  getFocusableElements: No,
  getFooter: fr,
  getHtmlContainer: Co,
  getIcon: Wt,
  getIconContent: Ec,
  getImage: dr,
  getInputLabel: kc,
  getLoader: Kt,
  getPopup: oe,
  getProgressSteps: To,
  getTimerLeft: Ed,
  getTimerProgressBar: Mn,
  getTitle: ur,
  getValidationMessage: $n,
  increaseTimer: xd,
  isDeprecatedParameter: jr,
  isLoading: Cc,
  isTimerRunning: Cd,
  isUpdatableParameter: Yr,
  isValidParameter: Hr,
  isVisible: gu,
  mixin: yd,
  off: Id,
  on: Ad,
  once: Od,
  resumeTimer: zr,
  showLoading: Ht,
  stopTimer: Xr,
  toggleTimer: kd
});
class Dd {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Jr = ["swal-title", "swal-html", "swal-footer"], Pd = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Hd(n), Object.assign($d(n), Md(n), Rd(n), Fd(n), Ud(n), Bd(n), Vd(n, Jr));
}, $d = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    It(o, ["name", "value"]);
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (s in wt && typeof wt[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "boolean" ? t[s] = r !== "false" : s in wt && typeof wt[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "object" ? t[s] = JSON.parse(r) : t[s] = r);
  }), t;
}, Md = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (t[s] = new Function(`return ${r}`)());
  }), t;
}, Rd = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    It(o, ["type", "color", "aria-label"]);
    const s = o.getAttribute("type");
    if (!s || !["confirm", "cancel", "deny"].includes(s))
      return;
    t[`${s}ButtonText`] = o.innerHTML, t[`show${Eo(s)}Button`] = !0;
    const r = o.getAttribute("color");
    r !== null && (t[`${s}ButtonColor`] = r);
    const a = o.getAttribute("aria-label");
    a !== null && (t[`${s}ButtonAriaLabel`] = a);
  }), t;
}, Fd = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    It(n, ["src", "width", "height", "alt"]);
    const o = n.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const s = n.getAttribute("width");
    s !== null && (t.imageWidth = s || void 0);
    const r = n.getAttribute("height");
    r !== null && (t.imageHeight = r || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, Ud = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (It(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Bd = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (It(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((s) => {
    It(s, ["value"]);
    const r = s.getAttribute("value");
    if (!r)
      return;
    const a = s.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, Vd = (e, t) => {
  const n = {};
  for (const o in t) {
    const s = t[o], r = e.querySelector(s);
    r && (It(r, []), n[s.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, Hd = (e) => {
  const t = Jr.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Ie(`Unrecognized element <${o}>`);
  });
}, It = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Ie([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Zr = 10, Yd = (e) => {
  var t, n;
  const o = Se(), s = oe();
  if (!o || !s)
    return;
  typeof e.willOpen == "function" && e.willOpen(s), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", s);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Gd(o, s, e), setTimeout(() => {
    jd(o, s);
  }, Zr), Ao() && (Wd(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), Tu()), Lu && e.backdrop === !1 && s.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !Rn() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const l = e.didOpen;
    setTimeout(() => l(s));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", s);
}, Nn = (e) => {
  const t = oe();
  if (!t || e.target !== t)
    return;
  const n = Se();
  n && (t.removeEventListener("animationend", Nn), t.removeEventListener("transitionend", Nn), n.style.overflowY = "auto", je(n, b["no-transition"]));
}, jd = (e, t) => {
  hr(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Nn), t.addEventListener("transitionend", Nn)) : e.style.overflowY = "auto";
}, Wd = (e, t, n) => {
  Nu(), t && n !== "hidden" && $u(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Gd = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && ne(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), xe(t, "grid"), setTimeout(() => {
    var s;
    (s = n.showClass) !== null && s !== void 0 && s.popup && ne(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Zr)) : xe(t, "grid"), ne([document.documentElement, document.body], b.shown), n.heightAuto && n.backdrop && !n.toast && ne([document.documentElement, document.body], b["height-auto"]);
};
var Cs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Kd(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Cs.email), e.input === "url" && (e.inputValidator = Cs.url));
}
function qd(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Ie('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Xd(e) {
  Kd(e), e.showLoaderOnConfirm && !e.preConfirm && Ie(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), qd(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Rc(e);
}
let et;
var pn = /* @__PURE__ */ new WeakMap();
class we {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (mc(
      this,
      pn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    et = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, pc(pn, this, this._main(et.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (Wr(Object.assign({}, n, t)), R.currentInstance) {
      const r = Vt.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), Ao() && Lr();
    }
    R.currentInstance = et;
    const o = Jd(t, n);
    Xd(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const s = Zd(et);
    return kr(et, o), re.innerParams.set(et, o), zd(et, s, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return hs(pn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return hs(pn, this).finally(t);
  }
}
const zd = (e, t, n) => new Promise((o, s) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Vt.swalPromiseResolve.set(e, o), Vt.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    Zu(e);
  }, t.denyButton.onclick = () => {
    Qu(e);
  }, t.cancelButton.onclick = () => {
    ed(e, r);
  }, t.closeButton.onclick = () => {
    r(qt.close);
  }, fd(n, t, r), vu(R, n, r), Yu(e, n), Yd(n), Qd(R, n, r), ef(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Jd = (e, t) => {
  const n = Pd(e), o = Object.assign({}, wt, t, n, e);
  return o.showClass = Object.assign({}, wt.showClass, o.showClass), o.hideClass = Object.assign({}, wt.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Zd = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        oe()
      ),
      container: (
        /** @type {HTMLElement} */
        Se()
      ),
      actions: (
        /** @type {HTMLElement} */
        an()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ot()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Dt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        Gt()
      ),
      loader: (
        /** @type {HTMLElement} */
        Kt()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Lo()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        $n()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        To()
      )
    }
  );
  return re.domCache.set(e, t), t;
}, Qd = (e, t, n) => {
  const o = Mn();
  Oe(o), t.timer && (e.timeout = new Dd(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (xe(o), Re(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && Io(
      /** @type {number} */
      t.timer
    );
  })));
}, ef = (e, t) => {
  if (!t.toast) {
    if (!Pn(t.allowEnterKey)) {
      cr("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    tf(e) || nf(e, t) || ro(-1, 1);
  }
}, tf = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && De(n))
      return n.focus(), !0;
  return !1;
}, nf = (e, t) => t.focusDeny && De(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && De(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && De(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
we.prototype.disableButtons = Rr;
we.prototype.enableButtons = Mr;
we.prototype.getInput = Dr;
we.prototype.disableInput = Ur;
we.prototype.enableInput = Fr;
we.prototype.hideLoading = Tn;
we.prototype.disableLoading = Tn;
we.prototype.showValidationMessage = Br;
we.prototype.resetValidationMessage = Vr;
we.prototype.close = gt;
we.prototype.closePopup = gt;
we.prototype.closeModal = gt;
we.prototype.closeToast = gt;
we.prototype.rejectPromise = Ar;
we.prototype.update = Gr;
we.prototype._destroy = Kr;
Object.assign(we, Sd);
Object.keys(dd).forEach((e) => {
  we[e] = function(...t) {
    if (et && et[e])
      return et[e](...t);
  };
});
we.DismissReason = qt;
we.version = "11.26.25";
const on = we;
on.default = on;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
function of(e, t) {
  const n = J({}), o = J({
    tz: "",
    merchant_name: "",
    memo1: "",
    memo2: ""
  }), s = J(!1), r = J(null);
  return { matrix: n, loading: s, error: r, merchantInfo: o, fetchMatrix: async (d = 1, h = 10) => {
    s.value = !0;
    try {
      n.value = await e.getSevenDayMatrix(d, h);
    } catch (w) {
      r.value = w.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  }, submitBooking: async (d) => {
    s.value = !0;
    try {
      return await e.createOrder(d);
    } catch (h) {
      throw r.value = h.message || "預約失敗", h;
    } finally {
      s.value = !1;
    }
  }, fetchMerchantInfo: async (d) => {
    s.value = !0;
    try {
      o.value = await t.getMerchantInfo(d);
    } catch (h) {
      r.value = h.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  } };
}
const sf = { class: "flex flex-col h-screen max-w-xl mx-auto bg-slate-100 font-sans text-slate-700 overflow-hidden" }, rf = { class: "flex-1 p-8 space-y-10 overflow-y-auto custom-scrollbar" }, af = { class: "space-y-3 py-4 text-left" }, lf = { class: "text-3xl font-black tracking-tighter border-l-4 border-slate-700 pl-4 leading-none" }, cf = ["innerHTML"], uf = { class: "space-y-4" }, df = { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, ff = { class: "relative isolate" }, mf = ["value"], pf = {
  key: 0,
  class: "space-y-4"
}, hf = { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, gf = { class: "flex gap-3 overflow-x-auto pb-4 no-scrollbar px-1" }, wf = ["onClick"], bf = { class: "text-[10px] font-black uppercase opacity-60" }, vf = { class: "text-xl font-black mt-1" }, _f = {
  key: 1,
  class: "mb-8"
}, yf = { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50 mb-3 ml-1" }, Ef = {
  key: 0,
  class: "p-8 text-center animate-pulse font-bold uppercase tracking-widest text-xs"
}, kf = {
  key: 1,
  class: "grid grid-cols-4 gap-2"
}, xf = ["onClick", "disabled"], Cf = {
  key: 0,
  class: "absolute bottom-1.5 w-3 h-[2px] bg-white/40 rounded-full"
}, Tf = {
  key: 2,
  class: "mt-4 text-center p-4 bg-slate-200/50 rounded-xl text-slate-500 text-[10px] font-bold uppercase tracking-wider"
}, Lf = { class: "space-y-4 pb-12" }, Nf = { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, Af = { class: "space-y-3" }, Of = ["onUpdate:modelValue", "type", "placeholder"], If = { class: "p-8 bg-slate-100 border-t border-slate-200" }, Sf = { class: "mb-3 text-center" }, Df = {
  key: 0,
  class: "text-[10px] font-black uppercase tracking-widest text-slate-400"
}, Pf = ["disabled"], $f = /* @__PURE__ */ ft({
  __name: "ReservationPage",
  props: {
    bookingApi: {},
    tzApi: {},
    merchantID: {}
  },
  setup(e) {
    it.extend(dc), it.locale("zh-tw");
    const { t } = jt(), n = e, { matrix: o, merchantInfo: s, loading: r, error: a, fetchMatrix: l, submitBooking: i, fetchMerchantInfo: d } = of(n.bookingApi, n.tzApi), h = J(2), w = J(""), p = J(""), x = J({
      name: "",
      phone: "",
      email: ""
    }), A = ["name", "phone", "email"], y = Ne(() => {
      var S;
      const U = o.value;
      if ((S = U == null ? void 0 : U["0"]) != null && S["0"]) return U[0][0];
      const ie = [];
      for (let I = 10; I <= 20; I++)
        ie.push(`${I.toString().padStart(2, "0")}:00`), I < 20 && ie.push(`${I.toString().padStart(2, "0")}:30`);
      return ie;
    }), k = Ne(() => o.value ? Object.fromEntries(Object.entries(o.value).filter(([U]) => U !== "0")) : {}), m = Ne(() => Object.keys(k.value).sort()), f = Ne(() => !w.value || !k.value[w.value] ? [] : k.value[w.value][h.value] || []), T = (U) => f.value.includes(U), _ = (U, ie) => it(U).format(ie);
    bt(k, (U) => {
      const ie = Object.keys(U).sort();
      ie.length > 0 && !w.value && (w.value = ie[0]);
    }, { deep: !0 }), bt([h, w], () => {
      p.value = "";
    }), An(async () => {
      d(n.merchantID), await l();
    });
    const N = (U) => /^\S+@\S+\.\S+$/.test(U), O = (U) => /^09\d{8}$/.test(U), E = Ne(() => w.value ? p.value ? x.value.name.trim() === "" ? "INVALID_NAME" : O(x.value.phone) ? N(x.value.email) ? "SUCCESS" : "INVALID_EMAIL" : "INVALID_PHONE" : "MISSING_TIME" : "MISSING_DATE"), K = Ne(() => E.value === "SUCCESS"), j = Ne(() => ({
      SUCCESS: t("booking.reservation.statusSuccess"),
      MISSING_DATE: t("booking.reservation.statusMissingDate"),
      MISSING_TIME: t("booking.reservation.statusMissingTime"),
      INVALID_NAME: t("booking.reservation.statusInvalidName"),
      INVALID_PHONE: t("booking.reservation.statusInvalidPhone"),
      INVALID_EMAIL: t("booking.reservation.statusInvalidEmail")
    })[E.value]), V = async () => {
      if (!K.value) return;
      const U = it(`${w.value} ${p.value}`).utc(!0).toISOString();
      try {
        await i({
          guest_count: h.value,
          merchant_name: s.value.merchant_name,
          start_time: U,
          name: x.value.name,
          phone: x.value.phone,
          email: x.value.email
        }), await on.fire({
          title: `<span class="font-black text-slate-700 uppercase tracking-tighter">${t("booking.reservation.confirmEmailTitle")}</span>`,
          html: `
        <div class="text-slate-600 font-bold leading-relaxed px-4 text-sm">
          ${t("booking.reservation.confirmEmailBody")}<br/>
          <span class="bg-slate-700 text-white px-3 py-1 rounded-full mt-2 inline-block">${x.value.email}</span><br/>
          <p class="mt-4 opacity-60 uppercase tracking-widest text-[10px]">${t("booking.reservation.confirmLinkExpiry")}</p>
        </div>`,
          icon: "success",
          iconColor: "#334155",
          background: "#f1f5f9",
          confirmButtonText: t("common.ok"),
          confirmButtonColor: "#334155",
          customClass: {
            popup: "rounded-[2.5rem] border-none shadow-2xl",
            confirmButton: "rounded-xl font-black px-10 py-3 tracking-widest"
          }
        }), await l();
      } catch (ie) {
        qn.error("預約失敗", ie), await on.fire({ title: "ERROR", text: t("booking.reservation.bookingFailed"), icon: "error", confirmButtonColor: "#334155" });
      }
    }, q = ["1de956ad-ea63-4e74-853a-8b24b4ef3d26", "8cba5a9b-8007-4a4c-830e-01d402f1ccc0"];
    return bt(() => n.merchantID, (U) => {
      U && q.includes(U) && (x.value = { name: t("booking.reservation.demoName"), phone: t("booking.reservation.demoPhone"), email: t("booking.reservation.demoEmail") });
    }, { immediate: !0 }), (U, ie) => (H(), Y("div", sf, [
      g("main", rf, [
        g("header", af, [
          g("h1", lf, z(W(s).merchant_name), 1),
          g("span", {
            class: "text-xs font-bold tracking-widest",
            innerHTML: W(s).memo2
          }, null, 8, cf)
        ]),
        g("section", uf, [
          g("label", df, z(W(t)("booking.reservation.guestsLabel")), 1),
          g("div", ff, [
            qe(g("select", {
              "onUpdate:modelValue": ie[0] || (ie[0] = (S) => h.value = S),
              class: "w-full appearance-none bg-white text-slate-700 p-5 rounded-2xl font-bold transition-all outline-none border-2 border-transparent focus:border-slate-700 shadow-sm cursor-pointer hover:bg-slate-50"
            }, [
              (H(), Y(Ce, null, Ke(8, (S) => g("option", {
                key: S,
                value: S
              }, z(W(t)("booking.reservation.guestOption", { n: S })), 9, mf)), 64))
            ], 512), [
              [Ts, h.value]
            ])
          ])
        ]),
        m.value.length ? (H(), Y("section", pf, [
          g("label", hf, z(W(t)("booking.reservation.dateLabel")), 1),
          g("div", gf, [
            (H(!0), Y(Ce, null, Ke(m.value, (S) => (H(), Y("button", {
              key: S,
              onClick: (I) => w.value = S,
              class: Pe([
                "min-w-[80px] py-5 rounded-2xl transition-all border-2 flex flex-col items-center shrink-0",
                w.value === S ? "bg-slate-700 text-white border-slate-700 shadow-lg" : "bg-white text-slate-700 border-transparent hover:border-slate-300 shadow-sm"
              ])
            }, [
              g("span", bf, z(_(S, "ddd")), 1),
              g("span", vf, z(_(S, "DD")), 1)
            ], 10, wf))), 128))
          ])
        ])) : $e("", !0),
        m.value.length ? (H(), Y("section", _f, [
          g("label", yf, z(W(t)("booking.reservation.timeLabel")), 1),
          W(r) ? (H(), Y("div", Ef, z(W(t)("booking.reservation.syncing")), 1)) : (H(), Y("div", kf, [
            (H(!0), Y(Ce, null, Ke(y.value, (S) => (H(), Y("button", {
              key: S,
              onClick: (I) => p.value = S,
              disabled: !T(S),
              class: Pe([
                /* 使用 px-0 釋放所有橫向空間，py-4 維持垂直厚度展現專業感 */
                /* text-[12px] 或 text-xs 是四欄布局的最佳平衡點 */
                "py-4 px-0 rounded-xl font-mono font-bold transition-all border-2 text-[12px] shadow-sm text-center relative flex items-center justify-center",
                p.value === S ? "bg-slate-700 text-white border-slate-700 shadow-md z-10 scale-[1.02]" : T(S) ? "bg-white text-slate-700 border-transparent hover:border-slate-300" : "bg-slate-50 text-slate-300 border-transparent cursor-not-allowed opacity-40"
              ])
            }, [
              Lt(z(S) + " ", 1),
              p.value === S ? (H(), Y("div", Cf)) : $e("", !0)
            ], 10, xf))), 128))
          ])),
          !W(r) && f.value.length === 0 ? (H(), Y("div", Tf, " ⚠️ " + z(W(t)("booking.reservation.noSlots")), 1)) : $e("", !0)
        ])) : $e("", !0),
        g("section", Lf, [
          g("label", Nf, z(W(t)("booking.reservation.infoLabel")), 1),
          g("div", Af, [
            (H(), Y(Ce, null, Ke(A, (S) => g("div", { key: S }, [
              qe(g("input", {
                "onUpdate:modelValue": (I) => x.value[S] = I,
                type: S === "email" ? "email" : "text",
                placeholder: S.toUpperCase(),
                class: "w-full p-5 bg-white rounded-xl border-2 border-transparent outline-none focus:border-slate-700 transition-all font-bold placeholder:text-slate-300 shadow-sm"
              }, null, 8, Of), [
                [aa, x.value[S]]
              ])
            ])), 64))
          ])
        ])
      ]),
      g("footer", If, [
        g("div", Sf, [
          Tt(lo, { name: "fade" }, {
            default: co(() => [
              !K.value && (w.value || p.value) ? (H(), Y("p", Df, z(W(t)("booking.reservation.statusLabel")) + ": " + z(j.value), 1)) : $e("", !0)
            ]),
            _: 1
          })
        ]),
        g("button", {
          onClick: V,
          disabled: !K.value || W(r),
          class: Pe([
            "w-full py-5 rounded-2xl font-black text-lg tracking-[0.3em] uppercase transition-all active:scale-[0.98]",
            K.value ? "bg-slate-700 text-white shadow-lg shadow-slate-300" : "bg-slate-200 text-slate-400 cursor-not-allowed"
          ])
        }, [
          W(r) ? (H(), Y(Ce, { key: 0 }, [
            Lt(z(W(t)("booking.reservation.processing")), 1)
          ], 64)) : (H(), Y(Ce, { key: 1 }, [
            Lt(z(K.value ? W(t)("booking.reservation.confirmOrder") : j.value), 1)
          ], 64))
        ], 10, Pf)
      ])
    ]));
  }
}), Em = /* @__PURE__ */ _o($f, [["__scopeId", "data-v-f9964b34"]]);
function Mf(e) {
  const t = J({}), n = J(!1), o = J(null);
  return { reservations: t, loading: n, error: o, loadData: async () => {
    n.value = !0, o.value = null;
    try {
      const r = await e.fetchReservations();
      t.value = r || {}, qn.log("載入預約資料成功:", t.value);
    } catch (r) {
      o.value = "無法載入預約資料", qn.error("載入預約資料失敗:", r);
    } finally {
      n.value = !1;
    }
  } };
}
const Rf = { class: "p-4 md:p-8 bg-slate-50 font-sans antialiased text-slate-700" }, Ff = { class: "max-w-5xl mx-auto" }, Uf = { class: "mb-8 flex flex-col md:flex-row md:items-center justify-between gap-6" }, Bf = { class: "flex flex-col gap-1" }, Vf = { class: "text-4xl font-black tracking-tight text-slate-700" }, Hf = { class: "text-slate-500 font-bold uppercase text-xs tracking-widest mt-1" }, Yf = { class: "text-indigo-700 font-black" }, jf = { class: "flex flex-wrap items-center gap-2 mb-8" }, Wf = ["onClick"], Gf = {
  key: 0,
  class: "mr-1"
}, Kf = ["disabled"], qf = {
  key: 0,
  class: "mb-10"
}, Xf = { class: "flex items-center gap-3 overflow-x-auto pb-4 no-scrollbar scroll-smooth" }, zf = ["onClick"], Jf = { class: "text-[10px] uppercase opacity-60 tracking-[0.2em] mb-1" }, Zf = { class: "text-xl leading-none tabular-nums" }, Qf = { class: "relative min-h-[700px]" }, em = { class: "flex items-center justify-between mb-4 px-2" }, tm = { class: "text-xs font-black text-slate-700 uppercase tracking-[0.3em]" }, nm = { class: "flex flex-col md:flex-row md:items-center gap-6" }, om = {
  key: 0,
  class: "flex -space-x-4"
}, sm = { class: "text-[8px] font-black opacity-60 uppercase mb-1" }, rm = { class: "text-2xl font-black leading-none" }, am = { class: "flex-1" }, im = { class: "flex-1 px-4 md:px-0" }, lm = { class: "flex items-center gap-3" }, cm = { class: "font-black text-slate-700 text-2xl tracking-tight leading-none" }, um = { class: "flex items-center gap-1 bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase" }, dm = { class: "flex flex-wrap items-center gap-x-6 gap-y-2 mt-3 text-sm text-slate-500 font-bold" }, fm = { class: "flex items-center gap-2" }, mm = {
  key: 0,
  class: "text-slate-700 hidden md:inline"
}, pm = {
  key: 1,
  class: "text-slate-700 font-medium"
}, hm = { class: "flex flex-row md:flex-col items-center md:items-end gap-4 px-4 md:px-0 md:pl-8 border-t md:border-t-0 md:border-l border-slate-100 pt-4 md:pt-0" }, gm = {
  key: 1,
  class: "text-center py-40 bg-white rounded-[3rem] border-4 border-dashed border-slate-100"
}, wm = { class: "text-2xl font-black text-slate-700 uppercase tracking-[0.2em]" }, bm = /* @__PURE__ */ ft({
  __name: "AdminReservationList",
  props: {
    api: {}
  },
  setup(e) {
    const { t } = jt(), n = e, { reservations: o, loading: s, error: r, loadData: a } = Mf(n.api);
    An(async () => {
      await a();
    });
    const l = J(null), i = J(2);
    J(null);
    const d = Ne(() => {
      const k = o.value;
      return k ? i.value === null ? Object.keys(k) : Object.keys(k).filter((m) => k[m].some((f) => f.status === i.value)) : [];
    });
    bt(d, (k) => {
      if (k.length > 0 && !l.value) {
        const m = it().format("YYYY-MM-DD");
        l.value = k.includes(m) ? m : k[0];
      }
    }, { immediate: !0 });
    const h = Ne(() => [
      { label: t("booking.admin.statusConfirmed"), value: 2, color: "green" },
      { label: t("booking.admin.statusAll"), value: null, color: "slate" }
    ]), w = Ne(() => {
      const k = o.value;
      if (!l.value || !k) return [];
      let m = k[l.value] || [];
      return i.value !== null && (m = m.filter((f) => f.status === i.value)), m;
    }), p = Ne(() => {
      const k = o.value;
      return k ? Object.values(k).reduce((m, f) => m + ((f == null ? void 0 : f.length) || 0), 0) : 0;
    }), x = (k) => {
      if (!k) return "slate";
      const m = it(k).hour();
      return m >= 5 && m < 12 ? "cyan" : m >= 12 && m < 17 ? "amber" : "indigo";
    }, A = (k) => {
      switch (k) {
        case 1:
          return "bg-orange-100 text-orange-700 border-orange-200";
        case 2:
          return "bg-green-100 text-green-700 border-green-200";
        case 3:
          return "bg-red-100 text-red-700 border-red-200";
      }
    }, y = (k) => k ? it(k).format("HH:mm") : "--:--";
    return (k, m) => (H(), Y("div", Rf, [
      g("div", Ff, [
        g("header", Uf, [
          g("div", Bf, [
            g("h1", Vf, z(W(t)("booking.admin.title")), 1),
            g("p", Hf, [
              m[1] || (m[1] = Lt(" 目前共有 ", -1)),
              g("span", Yf, z(p.value), 1),
              Lt(" " + z(W(t)("booking.admin.totalBookings")), 1)
            ])
          ]),
          g("div", jf, [
            (H(!0), Y(Ce, null, Ke(h.value, (f) => (H(), Y("button", {
              key: f.label,
              onClick: (T) => i.value = f.value,
              class: Pe([[
                i.value === f.value ? `bg-${f.color}-700 text-white shadow-lg` : `bg-white text-slate-700 hover:bg-${f.color}-100`
              ], "px-5 py-2 rounded-full border text-xs font-black uppercase tracking-wider transition-all active:scale-95"])
            }, [
              i.value === f.value ? (H(), Y("span", Gf, "●")) : $e("", !0),
              Lt(" " + z(f.label), 1)
            ], 10, Wf))), 128))
          ]),
          g("button", {
            onClick: m[0] || (m[0] = //@ts-ignore
            (...f) => W(a) && W(a)(...f)),
            disabled: W(s),
            class: "flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 rounded-2xl font-bold shadow-sm hover:shadow-md transition-all active:scale-95 disabled:opacity-50"
          }, [
            g("span", {
              class: Pe({ "animate-spin": W(s) })
            }, z(W(s) ? "⌛" : "🔄"), 3),
            Lt(" " + z(W(s) ? W(t)("booking.admin.loading") : W(t)("booking.admin.refreshBtn")), 1)
          ], 8, Kf)
        ]),
        d.value.length > 0 ? (H(), Y("div", qf, [
          g("nav", Xf, [
            (H(!0), Y(Ce, null, Ke(d.value, (f) => (H(), Y("button", {
              key: f,
              onClick: (T) => l.value = f,
              class: Pe([[
                l.value === f ? "bg-indigo-700 text-white shadow-xl shadow-indigo-100 scale-105 border-indigo-700" : "bg-white text-slate-500 hover:bg-slate-100 border-slate-200"
              ], "flex-shrink-0 px-6 py-4 rounded-[2rem] border-2 font-black transition-all duration-700 flex flex-col items-center min-w-[110px]"])
            }, [
              g("span", Jf, z(W(it)(f).format("ddd")), 1),
              g("span", Zf, z(W(it)(f).format("MM/DD")), 1)
            ], 10, zf))), 128))
          ])
        ])) : $e("", !0),
        g("div", Qf, [
          Tt(lo, {
            name: "list-fade",
            mode: "out-in"
          }, {
            default: co(() => [
              (H(), Y("div", {
                key: l.value || "none",
                class: "space-y-6"
              }, [
                w.value.length > 0 ? (H(), Y(Ce, { key: 0 }, [
                  g("div", em, [
                    g("h2", tm, z(W(t)("booking.admin.showing", { date: l.value, count: w.value.length })), 1)
                  ]),
                  (H(!0), Y(Ce, null, Ke(w.value, (f) => {
                    var T, _;
                    return H(), Y("div", {
                      key: f.booking_id,
                      class: Pe(["group rounded-[2.5rem] p-3 pr-8 shadow-sm border border-slate-100 hover:shadow-2xl hover:shadow-indigo-700 hover:border-indigo-100 transition-all duration-700", [
                        f.status === 1 ? "bg-orange-100" : "",
                        // 待處理 (Pending)
                        f.status === 2 ? "bg-green-100" : "",
                        // 已確認 (Confirmed)
                        f.status === 3 ? "bg-red-100" : "",
                        // 已取消 (Cancelled)
                        [1, 2, 3].includes(f.status) ? "" : "bg-white"
                        // 預設
                      ]])
                    }, [
                      g("div", nm, [
                        g("div", {
                          class: Pe([[`bg-${x((_ = (T = f.table_reservations) == null ? void 0 : T[0]) == null ? void 0 : _.booking_period.Lower)}-100/50`], "flex items-center gap-5 p-5 rounded-[2rem] md:w-80 transition-colors group-hover:bg-indigo-50"])
                        }, [
                          f.status !== 3 ? (H(), Y("div", om, [
                            (H(!0), Y(Ce, null, Ke(f.table_reservations, (N) => (H(), Y("div", {
                              key: N.id,
                              class: Pe([[`bg-${x(N.booking_period.Lower)}-700`], "w-16 h-16 text-white rounded-2xl flex flex-col items-center justify-center border-4 border-white shadow-md transition-all duration-700 group-hover:rotate-6 group-hover:scale-110"])
                            }, [
                              g("span", sm, z(W(t)("booking.admin.tableLabel")), 1),
                              g("span", rm, z(N.table_id), 1)
                            ], 2))), 128))
                          ])) : $e("", !0),
                          g("div", am, [
                            g("div", {
                              class: Pe([[`text-${x(f.start_time)}-700`], "text-2xl font-black tabular-nums tracking-tighter"])
                            }, z(y(f.start_time)), 3)
                          ])
                        ], 2),
                        g("div", im, [
                          g("div", lm, [
                            g("span", cm, z(f.guest_name), 1),
                            g("div", um, z(f.guest_count) + " " + z(W(t)("booking.admin.people")), 1)
                          ]),
                          g("div", dm, [
                            g("span", fm, "📞 " + z(f.phone_number), 1),
                            f.email ? (H(), Y("span", mm, "|")) : $e("", !0),
                            f.email ? (H(), Y("span", pm, "✉️ " + z(f.email), 1)) : $e("", !0)
                          ])
                        ]),
                        g("div", hm, [
                          g("div", {
                            class: Pe([A(f.status), "px-6 py-2 rounded-2xl text-[11px] font-black uppercase tracking-widest border transition-all shadow-sm"])
                          }, z(f.status === 2 ? "✓ " + W(t)("booking.admin.statusConfirmed") : f.status === 1 ? "• " + W(t)("booking.admin.statusPending") : "X " + W(t)("booking.admin.statusCancelled")), 3)
                        ])
                      ])
                    ], 2);
                  }), 128))
                ], 64)) : W(s) ? $e("", !0) : (H(), Y("div", gm, [
                  m[2] || (m[2] = g("div", { class: "text-6xl mb-6 grayscale opacity-20" }, "📅", -1)),
                  g("h2", wm, z(d.value.length > 0 ? W(t)("booking.admin.noBookingsDate") : W(t)("booking.admin.noBookingsAll")), 1)
                ]))
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ]));
  }
}), km = /* @__PURE__ */ _o(bm, [["__scopeId", "data-v-ccfbf63c"]]);
export {
  km as AdminReservationList,
  ym as BookingConfigPage,
  Em as ReservationPage,
  ml as useBookingConfig,
  of as useBookingOrder,
  Mf as useReservationAdmin
};
